// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* UsersTasksPage.css */
/* Базові стилі для світлої теми (дефолтні) */
.users-tasks-page {
    padding: 20px;
    max-width: 100%;
    background: #f5f5f5;
    min-height: 100vh;
    transition: background-color 0.3s ease;
}

/* ============================ */
/* СТИЛІ ДЛЯ ТЕМНОЇ ТЕМИ */
/* ============================ */

/* ФОН СТОРІНКИ */
.users-tasks-page.dark-theme {
    background-color: #1a202c !important;
}

/* ТЕКСТ ЗАГОЛОВКІВ */
.users-tasks-page.dark-theme .page-title,
.users-tasks-page.dark-theme .archive-section h2 {
    color: #ffffff !important;
}

/* ТЕКСТ ПОВІДОМЛЕНЬ */
.users-tasks-page.dark-theme .no-users,
.users-tasks-page.dark-theme .no-tasks,
.users-tasks-page.dark-theme .loading,
.users-tasks-page.dark-theme .error {
    color: #e2e8f0 !important;
}

/* КОНТЕЙНЕР КОРИСТУВАЧА - фон #414752 */
.users-tasks-page.dark-theme .user-column {
    background-color: #414752 !important;
    border-color: #565d6a !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3) !important;
}

.users-tasks-page.dark-theme .user-column:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4) !important;
}

/* ОБЛАСТЬ СТАТУСІВ КОРИСТУВАЧА - теж #414752 */
.users-tasks-page.dark-theme .user-statuses {
    background-color: #414752 !important;
}

/* КОНТЕЙНЕР ЗАГАЛЬНОГО ПУЛА */
.users-tasks-page.dark-theme .general-pool-section {
    background-color: #414752 !important;
    border-color: #565d6a !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3) !important;
}

/* ЗАГОЛОВОК КОРИСТУВАЧА - залишається кольоровим як у світлій темі */
.users-tasks-page.dark-theme .user-header {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
    color: white !important;
}

.users-tasks-page.dark-theme .user-header:hover {
    background: linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%) !important;
}

.users-tasks-page.dark-theme .user-column.collapsed .user-header {
    border-radius: 8px !important;
}

/* ІКОНКА РОЛІ */
.users-tasks-page.dark-theme .role-icon {
    background: rgba(255, 255, 255, 0.2) !important;
}

/* КНОПКА ЗГОРНУТИ/РОЗГОРНУТИ */
.users-tasks-page.dark-theme .collapse-btn {
    background: rgba(255, 255, 255, 0.2) !important;
    color: white !important;
}

.users-tasks-page.dark-theme .collapse-btn:hover {
    background: rgba(255, 255, 255, 0.3) !important;
}

/* ============================ */
/* СТИЛІ ДЛЯ ЗАДАЧ ТА СТАТУСІВ (ЗАЛИШАЮТЬСЯ НЕЗМІННИМИ) */
/* ============================ */

/* КОНТЕЙНЕР СТАТУСУ - залишається білим */
.users-tasks-page.dark-theme .status-section {
    background: white !important;
    border: 1px solid #e1e5e9 !important;
    border-radius: 8px !important;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05) !important;
}

/* ЗАГОЛОВОК СТАТУСУ - залишається світлим */
.users-tasks-page.dark-theme .status-header {
    background: #f8f9fa !important;
    border-bottom: 1px solid #e9ecef !important;
}

.users-tasks-page.dark-theme .status-header:hover {
    background: #e9ecef !important;
}

/* НАЗВА СТАТУСУ - залишається темною */
.users-tasks-page.dark-theme .status-name {
    color: #495057 !important;
    font-weight: 600 !important;
}

/* ЛІЧИЛЬНИК ЗАДАЧ - залишається як у світлій темі */
.users-tasks-page.dark-theme .task-count {
    background: #6c757d !important;
    color: white !important;
    padding: 3px 8px !important;
    border-radius: 12px !important;
    font-size: 11px !important;
    font-weight: 600 !important;
}

/* ІКОНКА ЗГОРНУТИ СТАТУС */
.users-tasks-page.dark-theme .collapse-icon {
    color: #6c757d !important;
}

/* СПИСОК ЗАДАЧ - залишається білим */
.users-tasks-page.dark-theme .tasks-list {
    background: white !important;
}

/* КАРТКА ЗАДАЧІ - залишається як у світлій темі */
.users-tasks-page.dark-theme .task-item {
    background: #f8f9fa !important;
    border-bottom: 1px solid #f1f3f4 !important;
    border-radius: 6px !important;
    cursor: pointer !important;
}

.users-tasks-page.dark-theme .task-item:hover {
    background: #e9ecef !important;
}

.users-tasks-page.dark-theme .task-item.blocker {
    background: #fff5f5 !important;
    border-left: 4px solid #dc3545 !important;
}

.users-tasks-page.dark-theme .task-item.expired {
    background: #fff5f5 !important;
}

/* НАЗВА ЗАДАЧІ - залишається темною */
.users-tasks-page.dark-theme .task-name {
    color: #333 !important;
    font-size: 13px !important;
    font-weight: 500 !important;
}

/* ПРОЕКТ ЗАДАЧІ - залишається сірим */
.users-tasks-page.dark-theme .task-project {
    color: #666 !important;
    font-size: 0.8em !important;
}

/* КНОПКА АРХІВУВАННЯ - залишається як у світлій темі */
.users-tasks-page.dark-theme .archive-btn {
    background: none !important;
    border: none !important;
    color: #333 !important;
    font-size: 16px !important;
    cursor: pointer !important;
}

.users-tasks-page.dark-theme .archive-btn:hover {
    background: rgba(0, 0, 0, 0.1) !important;
}

/* ТАЙМЕРИ - залишаються темними */
.users-tasks-page.dark-theme .task-times-container {
    border-top: 1px solid rgba(0, 0, 0, 0.05) !important;
}

.users-tasks-page.dark-theme .planned-time-remaining {
    border-top: 1px dashed rgba(0, 0, 0, 0.1) !important;
}

.users-tasks-page.dark-theme .time-value {
    color: #333 !important;
    font-weight: 600 !important;
    font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace !important;
}

/* ============================ */
/* КОЛЬОРИ СТАТУСІВ (ЗАЛИШАЮТЬСЯ ЯК У СВІТЛІЙ ТЕМІ) */
/* ============================ */

/* Черговому - фіолетовий */
.users-tasks-page.dark-theme .status-name[data-status="Черговому"],
.users-tasks-page.dark-theme .status-name[data-status="Дежурному"] {
    background-color: #e6e6ff !important;
    color: #4d4dff !important;
    border: 1px solid #ccccff !important;
}

/* В роботі - синій */
.users-tasks-page.dark-theme .status-name[data-status="В роботі"],
.users-tasks-page.dark-theme .status-name[data-status="В работе"] {
    background-color: #e6f2ff !important;
    color: #0066cc !important;
    border: 1px solid #b3d9ff !important;
}

/* В черзі - оранжевий */
.users-tasks-page.dark-theme .status-name[data-status="В черзі"],
.users-tasks-page.dark-theme .status-name[data-status="В очереди"] {
    background-color: #fff2e6 !important;
    color: #cc6600 !important;
    border: 1px solid #ffd9b3 !important;
}

/* В черзі (м'яч не у нас) - сірий */
.users-tasks-page.dark-theme .status-name[data-status="В черзі (м'яч не у нас)"],
.users-tasks-page.dark-theme .status-name[data-status="В очереди (мяч не у нас)"] {
    background-color: #d8d1d1 !important;
    color: #756f6f !important;
    border: 1px solid #463f3f !important;
}

/* Відкладене - сірий */
.users-tasks-page.dark-theme .status-name[data-status="Відкладене"],
.users-tasks-page.dark-theme .status-name[data-status="Отложенная"] {
    background-color: #f2f2f2 !important;
    color: #666666 !important;
    border: 1px solid #d9d9d9 !important;
    text-decoration: line-through !important;
}

/* Скасоване - темно-сірий */
.users-tasks-page.dark-theme .status-name[data-status="Скасоване"],
.users-tasks-page.dark-theme .status-name[data-status="Canceled"] {
    background-color: #e6e6e6 !important;
    color: #999999 !important;
    border: 1px solid #cccccc !important;
    text-decoration: line-through !important;
}

/* Виконане - зелений */
.users-tasks-page.dark-theme .status-name[data-status="Виконане"],
.users-tasks-page.dark-theme .status-name[data-status="Completed"] {
    background-color: #e6ffe6 !important;
    color: #009900 !important;
    border: 1px solid #b3ffb3 !important;
}

/* ============================ */
/* ІНШІ ЕЛЕМЕНТИ ТЕМНОЇ ТЕМИ */
/* ============================ */

/* КНОПКИ ФІЛЬТРІВ */
.users-tasks-page.dark-theme .filter-btn {
    background: #2d3748 !important;
    border: 2px solid #4a5568 !important;
    color: #a0aec0 !important;
}

.users-tasks-page.dark-theme .filter-btn:hover {
    border-color: #667eea !important;
    color: #667eea !important;
}

.users-tasks-page.dark-theme .filter-btn.active {
    border-color: #667eea !important;
    background: #667eea !important;
    color: white !important;
}

/* КНОПКА АРХІВУ */
.users-tasks-page.dark-theme .archive-toggle-btn {
    background: #2d3748 !important;
    border: 2px solid #4a5568 !important;
    color: #a0aec0 !important;
}

.users-tasks-page.dark-theme .archive-toggle-btn:hover {
    border-color: #667eea !important;
    color: #667eea !important;
}

.users-tasks-page.dark-theme .archive-toggle-btn.active {
    border-color: #667eea !important;
    background: #667eea !important;
    color: white !important;
}

/* КНОПКИ НАЛАШТУВАНЬ */
.users-tasks-page.dark-theme .settings-btn,
.users-tasks-page.dark-theme .display-mode-btn {
    background: #2d3748 !important;
    border: 2px solid #4a5568 !important;
    color: #a0aec0 !important;
}

.users-tasks-page.dark-theme .settings-btn:hover,
.users-tasks-page.dark-theme .display-mode-btn:hover {
    background: #667eea !important;
    border-color: #667eea !important;
    color: white !important;
}

/* МОДАЛЬНІ ВІКНА */
.users-tasks-page.dark-theme .settings-modal,
.users-tasks-page.dark-theme .display-mode-modal {
    background-color: #414752 !important;
    border: 1px solid #565d6a !important;
    color: #e2e8f0 !important;
}

.users-tasks-page.dark-theme .settings-content h3,
.users-tasks-page.dark-theme .display-mode-content h3 {
    color: #ffffff !important;
}

.users-tasks-page.dark-theme .settings-hint,
.users-tasks-page.dark-theme .mode-hint {
    color: #a0aec0 !important;
}

.users-tasks-page.dark-theme .settings-hint strong,
.users-tasks-page.dark-theme .mode-hint strong {
    color: #667eea !important;
}

/* КНОПКИ В МОДАЛЬНИХ ВІКНАХ */
.users-tasks-page.dark-theme .position-btn,
.users-tasks-page.dark-theme .mode-btn {
    background: #2d3748 !important;
    border: 2px solid #4a5568 !important;
    color: #e2e8f0 !important;
}

.users-tasks-page.dark-theme .position-btn:hover,
.users-tasks-page.dark-theme .mode-btn:hover {
    border-color: #667eea !important;
    color: #667eea !important;
}

.users-tasks-page.dark-theme .position-btn.active,
.users-tasks-page.dark-theme .mode-btn.active {
    border-color: #667eea !important;
    background: #667eea !important;
    color: white !important;
}

/* КНОПКИ ЗАКРИТИ */
.users-tasks-page.dark-theme .close-settings,
.users-tasks-page.dark-theme .close-mode {
    background: #2d3748 !important;
    color: #e2e8f0 !important;
    border: none !important;
}

.users-tasks-page.dark-theme .close-settings:hover,
.users-tasks-page.dark-theme .close-mode:hover {
    background: #4a5568 !important;
}

/* АРХІВОВАНІ ЗАДАЧІ */
.users-tasks-page.dark-theme .task-item.archived {
    background: #f8f9fa !important;
    border-left: 4px solid #6c757d !important;
}

.users-tasks-page.dark-theme .task-meta {
    color: #6c757d !important;
}

.users-tasks-page.dark-theme .restore-btn {
    background: none !important;
    border: none !important;
    color: #333 !important;
}

.users-tasks-page.dark-theme .restore-btn:hover {
    background: rgba(40, 167, 69, 0.1) !important;
}

/* ============================ */
/* ОРИГІНАЛЬНІ СТИЛІ СВІТЛОЇ ТЕМИ (БЕЗ ЗМІН) */
/* ============================ */

.users-tasks-page .page-title {
    text-align: center;
    margin-bottom: 20px;
    color: #333;
    font-size: 24px;
    font-weight: 600;
}

.users-tasks-page .layout-container {
    display: grid;
    grid-template-columns: 1fr 300px;
    gap: 20px;
    align-items: start;
}

.users-tasks-page .users-section {
    min-height: 400px;
}

.users-tasks-page .users-grid {
    display: flex;
    gap: 12px;
    padding: 10px;
    overflow-x: auto;
    align-items: flex-start;
}

.users-tasks-page .user-column {
    min-width: 280px;
    max-width: 320px;
    background: white;
    border-radius: 12px;
    border: 1px solid #e1e5e9;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    flex-shrink: 0;
    transition: transform 0.2s ease;
    overflow: hidden;
}

.users-tasks-page .user-column.collapsed {
    min-width: 120px;
    max-width: 140px;
}

.users-tasks-page .user-column:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.users-tasks-page .user-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    cursor: pointer;
    min-height: 60px;
    transition: background-color 0.2s;
}

.users-tasks-page .user-header:hover {
    background: linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%);
}

.users-tasks-page .user-column.collapsed .user-header {
    border-radius: 8px;
    min-height: 50px;
    padding: 10px 12px;
}

.users-tasks-page .user-name {
    font-weight: 600;
    font-size: 15px;
    word-wrap: break-word;
    max-width: 200px;
    line-height: 1.3;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.users-tasks-page .user-column.collapsed .user-name {
    font-size: 13px;
    max-width: 80px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.users-tasks-page .general-pool-section {
    background: white;
    border-radius: 12px;
    border: 1px solid #e1e5e9;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    overflow: hidden;
}

.users-tasks-page .pool-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
    color: white;
    cursor: pointer;
}

.users-tasks-page .pool-header-left {
    display: flex;
    align-items: center;
    gap: 10px;
}

.users-tasks-page .pool-title {
    font-size: 18px;
    font-weight: 600;
    margin: 0;
    color: white;
}

.users-tasks-page .collapse-btn {
    background: rgba(255, 255, 255, 0.2);
    border: none;
    color: white;
    cursor: pointer;
    font-size: 12px;
    padding: 6px 10px;
    border-radius: 6px;
    transition: background-color 0.2s;
    flex-shrink: 0;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.users-tasks-page .collapse-btn:hover {
    background: rgba(255, 255, 255, 0.3);
}

.users-tasks-page .user-statuses {
    padding: 12px;
    max-height: 600px;
    overflow-y: auto;
}

.users-tasks-page .status-section {
    margin-bottom: 12px;
    border: 1px solid #e1e5e9;
    border-radius: 8px;
    overflow: hidden;
    background: white;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.users-tasks-page .status-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 12px;
    background: #f8f9fa;
    cursor: pointer;
    transition: background-color 0.2s;
    font-size: 13px;
    border-bottom: 1px solid #e9ecef;
}

.users-tasks-page .status-header:hover {
    background: #e9ecef;
}

.users-tasks-page .status-name {
    font-weight: 600;
    color: #495057;
    flex: 1 1;
    padding: 4px 8px;
    border-radius: 4px;
    margin-right: 5px;
    font-size: 12px;
    display: inline-block;
}

.users-tasks-page .task-count {
    background: #6c757d;
    color: white;
    padding: 3px 8px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 600;
    margin: 0 8px;
    min-width: 24px;
    text-align: center;
}

.users-tasks-page .collapse-icon {
    font-size: 10px;
    color: #6c757d;
    transition: transform 0.2s;
}

.users-tasks-page .tasks-list {
    background: white;
    max-height: 300px;
    overflow-y: auto;
}

.users-tasks-page .general-pool-tasks {
    padding: 15px;
    max-height: 600px;
    overflow-y: auto;
}

.users-tasks-page .task-item {
    padding: 12px;
    border-bottom: 1px solid #f1f3f4;
    transition: background-color 0.2s;
    position: relative;
    border-radius: 6px;
    margin-bottom: 8px;
    background: #f8f9fa;
    cursor: pointer;
}

.users-tasks-page .task-item:hover {
    background: #e9ecef;
}

.users-tasks-page .task-item:last-child {
    border-bottom: none;
    margin-bottom: 0;
}

.users-tasks-page .task-item.blocker {
    background: #fff5f5;
    border-left: 4px solid #dc3545;
}

.users-tasks-page .task-name {
    font-size: 13px;
    color: #333;
    margin-bottom: 6px;
    line-height: 1.4;
    word-wrap: break-word;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.users-tasks-page .task-project {
    font-size: 0.8em;
    color: #666;
    margin-top: 4px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.users-tasks-page .task-time {
    font-size: 11px;
    color: #6c757d;
    background: white;
    padding: 3px 8px;
    border-radius: 6px;
    display: inline-block;
    font-weight: 600;
    border: 1px solid #e9ecef;
}

.users-tasks-page .task-blocker {
    font-size: 10px;
    color: #dc3545;
    background: #f8d7da;
    padding: 3px 8px;
    border-radius: 6px;
    display: inline-block;
    margin-top: 6px;
    font-weight: 700;
    border: 1px solid #f5c6cb;
}

.users-tasks-page .loading, 
.users-tasks-page .error {
    text-align: center;
    padding: 40px;
    font-size: 18px;
}

.users-tasks-page .loading {
    color: #007bff;
}

.users-tasks-page .error {
    color: #dc3545;
}

.users-tasks-page .no-users, 
.users-tasks-page .no-tasks {
    text-align: center;
    padding: 40px;
    color: #6c757d;
    font-size: 16px;
    background: white;
    border-radius: 8px;
    margin: 20px;
}

/* Стилі для скролу */
.users-tasks-page .users-grid::-webkit-scrollbar {
    height: 8px;
}

.users-tasks-page .users-grid::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
}

.users-tasks-page .users-grid::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
}

.users-tasks-page .users-grid::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}

.users-tasks-page .tasks-list::-webkit-scrollbar,
.users-tasks-page .general-pool-tasks::-webkit-scrollbar {
    width: 6px;
}

.users-tasks-page .tasks-list::-webkit-scrollbar-track,
.users-tasks-page .general-pool-tasks::-webkit-scrollbar-track {
    background: #f1f1f1;
}

.users-tasks-page .tasks-list::-webkit-scrollbar-thumb,
.users-tasks-page .general-pool-tasks::-webkit-scrollbar-thumb {
    background: #d1d1d1;
    border-radius: 3px;
}

/* Адаптивність для мобільних пристроїв */
@media (max-width: 1024px) {
    .users-tasks-page .layout-container {
        grid-template-columns: 1fr;
        gap: 15px;
    }
    
    .users-tasks-page .general-pool-section {
        order: -1;
    }
}

@media (max-width: 768px) {
    .users-tasks-page {
        padding: 10px;
    }
    
    .users-tasks-page .users-grid {
        gap: 8px;
        padding: 5px;
    }
    
    .users-tasks-page .user-column {
        min-width: 260px;
    }
    
    .users-tasks-page .user-column.collapsed {
        min-width: 100px;
        max-width: 120px;
    }
    
    .users-tasks-page .user-name {
        font-size: 14px;
        max-width: 180px;
    }
    
    .users-tasks-page .user-column.collapsed .user-name {
        font-size: 12px;
        max-width: 70px;
    }
    
    .users-tasks-page .user-header {
        padding: 12px;
        min-height: 55px;
    }
    
    .users-tasks-page .user-column.collapsed .user-header {
        min-height: 45px;
        padding: 8px 10px;
    }
}

@media (max-width: 480px) {
    .users-tasks-page .user-column {
        min-width: 240px;
    }
    
    .users-tasks-page .user-column.collapsed {
        min-width: 90px;
        max-width: 100px;
    }
    
    .users-tasks-page .user-name {
        font-size: 13px;
        max-width: 160px;
    }
    
    .users-tasks-page .user-column.collapsed .user-name {
        font-size: 11px;
        max-width: 60px;
    }
    
    .users-tasks-page .status-header {
        padding: 8px 10px;
        font-size: 12px;
    }
    
    .users-tasks-page .task-item {
        padding: 8px 10px;
    }
    
    .users-tasks-page .task-name {
        font-size: 12px;
    }
    
    .users-tasks-page .page-title {
        font-size: 20px;
    }
}

.users-tasks-page .page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.users-tasks-page .archive-toggle-btn {
    background: #007bff;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
    font-size: 14px;
}

.users-tasks-page .archive-toggle-btn.active {
    background: #28a745;
}

.users-tasks-page .archive-toggle-btn:hover {
    opacity: 0.9;
}

.users-tasks-page .archive-section {
    margin-top: 20px;
}

.users-tasks-page .archive-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 15px;
    margin-top: 20px;
}

.users-tasks-page .task-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 5px;
}

.users-tasks-page .archive-btn, .restore-btn {
    background: none;
    border: none;
    font-size: 16px;
    cursor: pointer;
    padding: 2px 5px;
    border-radius: 3px;
}

.users-tasks-page .archive-btn:hover {
    background: rgba(0, 0, 0, 0.1);
}

.users-tasks-page .restore-btn:hover {
    background: rgba(40, 167, 69, 0.1);
}

.users-tasks-page .task-item.archived {
    background: #f8f9fa;
    border-left: 4px solid #6c757d;
}

.users-tasks-page .task-meta {
    font-size: 12px;
    color: #6c757d;
    margin-top: 5px;
}

.users-tasks-page .task-meta div {
    margin-bottom: 2px;
}

/* Черговому - фіолетовий */
.users-tasks-page .status-name[data-status="Черговому"],
.users-tasks-page .status-name[data-status="Дежурному"] {
    background-color: #e6e6ff;
    color: #4d4dff;
    border: 1px solid #ccccff;
}

/* В роботі - синій */
.users-tasks-page .status-name[data-status="В роботі"],
.users-tasks-page .status-name[data-status="В работе"] {
    background-color: #e6f2ff;
    color: #0066cc;
    border: 1px solid #b3d9ff;
}

/* В черзі - оранжевий */
.users-tasks-page .status-name[data-status="В черзі"],
.users-tasks-page .status-name[data-status="В очереди"] {
    background-color: #fff2e6;
    color: #cc6600;
    border: 1px solid #ffd9b3;
}

/* В черзі (м'яч не у нас) - сірий */
.users-tasks-page .status-name[data-status="В черзі (м'яч не у нас)"],
.users-tasks-page .status-name[data-status="В очереди (мяч не у нас)"] {
    background-color: #d8d1d1;
    color: #756f6f;
    border: 1px solid #463f3f;
}

/* Відкладене - сірий */
.users-tasks-page .status-name[data-status="Відкладене"],
.users-tasks-page .status-name[data-status="Отложенная"] {
    background-color: #f2f2f2;
    color: #666666;
    border: 1px solid #d9d9d9;
    text-decoration: line-through;
}

/* Скасоване - темно-сірий */
.users-tasks-page .status-name[data-status="Скасоване"],
.users-tasks-page .status-name[data-status="Canceled"] {
    background-color: #e6e6e6;
    color: #999999;
    border: 1px solid #cccccc;
    text-decoration: line-through;
}

/* Виконане - зелений */
.users-tasks-page .status-name[data-status="Виконане"],
.users-tasks-page .status-name[data-status="Completed"] {
    background-color: #e6ffe6;
    color: #009900;
    border: 1px solid #b3ffb3;
}

.user-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 15px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border-radius: 8px 8px 0 0;
    cursor: pointer;
    font-weight: bold;
}

.user-name {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 16px;
}

.role-icon {
    font-size: 18px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.status-header {
    display: flex;
    align-items: center;
    padding: 8px 12px;
    background-color: #f0f0f0;
    border-radius: 4px;
    margin-top: 5px;
    cursor: pointer;
}

.status-name {
    flex-grow: 1;
    font-weight: 600;
}

.task-count {
    margin: 0 10px;
    color: #666;
}

.collapse-icon {
    color: #888;
}

.user-column.collapsed .user-header {
    border-radius: 8px;
}

.user-column.collapsed .user-statuses {
    display: none;
}

/* Стилі для кнопок фільтрації ролей */
.filter-buttons {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    margin-bottom: 15px;
}

.filter-btn {
    padding: 8px 12px;
    border: 2px solid #e0e0e0;
    border-radius: 20px;
    background: white;
    color: #666;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 5px;
}

.filter-btn:hover {
    border-color: #667eea;
    color: #667eea;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(102, 126, 234, 0.1);
}

.filter-btn.active {
    border-color: #667eea;
    background: #667eea;
    color: white;
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
}

.filter-btn.active:hover {
    background: #5a67d8;
    border-color: #5a67d8;
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(90, 103, 216, 0.25);
}

/* Стилі для кнопки архіву */
.archive-toggle-btn {
    padding: 8px 16px;
    border: 2px solid #e0e0e0;
    border-radius: 20px;
    background: white;
    color: #666;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.3s ease;
    white-space: nowrap;
}

.archive-toggle-btn:hover {
    border-color: #667eea;
    color: #667eea;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(102, 126, 234, 0.1);
}

.archive-toggle-btn.active {
    border-color: #667eea;
    background: #667eea;
    color: white;
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
}

.archive-toggle-btn.active:hover {
    background: #5a67d8;
    border-color: #5a67d8;
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(90, 103, 216, 0.25);
}

/* Стилі для кнопки згортання користувача */
.collapse-btn {
    background: none;
    border: none;
    color: white;
    font-size: 12px;
    cursor: pointer;
    padding: 5px;
    border-radius: 4px;
    transition: all 0.2s ease;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.collapse-btn:hover {
    background: rgba(255, 255, 255, 0.2);
    transform: scale(1.1);
}

/* Стилі для іконки згортання статусів */
.collapse-icon {
    color: #888;
    font-size: 12px;
    margin-left: 5px;
    transition: transform 0.2s ease;
}

.status-header:hover .collapse-icon {
    color: #667eea;
}

/* Стилі для заголовка користувача з іконкою ролі */
.user-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 15px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border-radius: 8px 8px 0 0;
    cursor: pointer;
    font-weight: bold;
    min-height: 44px;
    transition: all 0.3s ease;
}

.user-header:hover {
    background: linear-gradient(135deg, #5a67d8 0%, #6b46a1 100%);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
}

.user-name {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 16px;
    flex: 1 1;
}

.role-icon {
    font-size: 18px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
}

.user-header:hover .role-icon {
    background: rgba(255, 255, 255, 0.3);
    transform: scale(1.1);
}

/* Стилі для заголовка статусу */
.status-header {
    display: flex;
    align-items: center;
    padding: 8px 12px;
    background-color: #f8f9fa;
    border-radius: 6px;
    margin-top: 5px;
    cursor: pointer;
    transition: all 0.2s ease;
    border-left: 3px solid transparent;
}

.status-header:hover {
    background-color: #e9ecef;
    border-left-color: #667eea;
    transform: translateX(2px);
}

.status-name {
    flex-grow: 1;
    font-weight: 600;
    color: #333;
}

.task-count {
    margin: 0 10px;
    color: #6c757d;
    font-size: 14px;
    background: rgba(108, 117, 125, 0.1);
    padding: 2px 8px;
    border-radius: 12px;
    font-weight: 500;
}

/* Анімація для згорнутого стану */
.user-column.collapsed .user-header {
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.user-column.collapsed .user-statuses {
    display: none;
}

/* Плавна анімація при згортанні/розгортанні */
.user-statuses {
    transition: all 0.3s ease;
    overflow: hidden;
}

.status-section {
    transition: all 0.3s ease;
}

.tasks-list {
    transition: all 0.3s ease;
    overflow: hidden;
}

/* Стилі для індикатора активності фільтра */
.filter-btn:not(.active) {
    opacity: 0.7;
}

.filter-btn:not(.active):hover {
    opacity: 1;
}

/* Медіа-запити для адаптивності */
@media (max-width: 768px) {
    .filter-buttons {
        gap: 5px;
    }
    
    .filter-btn {
        padding: 6px 10px;
        font-size: 13px;
    }
    
    .archive-toggle-btn {
        padding: 6px 12px;
        font-size: 13px;
    }
    
    .header-info {
        flex-direction: column;
        gap: 10px;
    }
}

@media (max-width: 480px) {
    .filter-buttons {
        flex-direction: column;
        width: 100%;
    }
    
    .filter-btn {
        width: 100%;
        justify-content: center;
    }
}

.users-tasks-page .task-times-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2px;
    margin-top: 4px;
    padding: 4px 0;
    border-top: 1px solid rgba(0, 0, 0, 0.05);
}

.users-tasks-page .total-time-in-status {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 2px 0;
}

.users-tasks-page .planned-time-remaining {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 2px 0;
    border-top: 1px dashed rgba(0, 0, 0, 0.1);
}

.users-tasks-page .time-row {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
}

.users-tasks-page .time-value {
    font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
    font-weight: 600;
    text-align: center;
}

/* Для мобільних пристроїв */
@media (max-width: 768px) {
    .users-tasks-page .task-times-container {
        gap: 1px;
    }
    
    .users-tasks-page .time-value {
        font-size: 11px;
    }
}

/* Стилі для кнопки налаштувань */
.page-header-left {
    display: flex;
    align-items: center;
    gap: 15px;
    position: relative;
}

.settings-btn {
    background: #f8f9fa;
    border: 2px solid #e0e0e0;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 18px;
    transition: all 0.3s ease;
}

.settings-btn:hover {
    background: #667eea;
    border-color: #667eea;
    color: white;
    transform: rotate(90deg);
}

/* Модальне вікно налаштувань */
.settings-modal {
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 1000;
    background: white;
    border-radius: 12px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
    min-width: 280px;
    margin-top: 10px;
    border: 1px solid #e0e0e0;
    overflow: hidden;
}

.settings-content {
    padding: 20px;
}

.settings-content h3 {
    margin: 0 0 15px 0;
    color: #333;
    font-size: 16px;
    text-align: center;
}

.position-options {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 15px;
}

.position-btn {
    padding: 12px 20px;
    border: 2px solid #e0e0e0;
    border-radius: 8px;
    background: white;
    color: #666;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.3s ease;
    text-align: center;
}

.position-btn:hover {
    border-color: #667eea;
    color: #667eea;
    transform: translateY(-2px);
}

.position-btn.active {
    border-color: #667eea;
    background: #667eea;
    color: white;
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
}

.position-btn.active:hover {
    background: #5a67d8;
    border-color: #5a67d8;
}

.settings-hint {
    text-align: center;
    font-size: 14px;
    color: #666;
    margin-bottom: 15px;
}

.settings-hint strong {
    color: #667eea;
}

.close-settings {
    width: 100%;
    padding: 10px;
    border: none;
    border-radius: 8px;
    background: #f8f9fa;
    color: #666;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.3s ease;
}

.close-settings:hover {
    background: #e9ecef;
}

/* Стилі для компонента внизу */
.general-pool-section.bottom {
    grid-column: 1 / -1;
    margin-top: 20px;
}

/* Адаптивність для мобільних пристроїв */
@media (max-width: 1024px) {
    .layout-container {
        grid-template-columns: 1fr !important;
    }
    
    .general-pool-section {
        order: 1 !important;
        margin-top: 20px;
    }
    
    .users-section {
        order: -1 !important;
    }
}

@media (max-width: 768px) {
    .page-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 15px;
    }
    
    .page-header-left {
        width: 100%;
        justify-content: space-between;
    }
    
    .settings-modal {
        left: auto;
        right: 0;
    }
}

@media (max-width: 480px) {
    .settings-modal {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 90%;
        max-width: 300px;
    }
    
    .position-options {
        flex-direction: row;
        flex-wrap: wrap;
    }
    
    .position-btn {
        flex: 1 1;
        min-width: 80px;
    }
}

/* Стилі для кнопок управління */
.header-controls {
    display: flex;
    gap: 10px;
    align-items: center;
}

.display-mode-btn,
.settings-btn {
    background: #f8f9fa;
    border: 2px solid #e0e0e0;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 18px;
    transition: all 0.3s ease;
}

.display-mode-btn:hover,
.settings-btn:hover {
    background: #667eea;
    border-color: #667eea;
    color: white;
    transform: rotate(90deg);
}

/* Модальне вікно режиму відображення */
.display-mode-modal {
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 1001;
    background: white;
    border-radius: 12px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
    min-width: 280px;
    margin-top: 10px;
    border: 1px solid #e0e0e0;
    overflow: hidden;
}

.display-mode-content {
    padding: 20px;
}

.display-mode-content h3 {
    margin: 0 0 15px 0;
    color: #333;
    font-size: 16px;
    text-align: center;
}

.mode-options {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 15px;
}

.mode-btn {
    padding: 12px 20px;
    border: 2px solid #e0e0e0;
    border-radius: 8px;
    background: white;
    color: #666;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.3s ease;
    text-align: center;
}

.mode-btn:hover {
    border-color: #667eea;
    color: #667eea;
    transform: translateY(-2px);
}

.mode-btn.active {
    border-color: #667eea;
    background: #667eea;
    color: white;
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
}

.mode-btn.active:hover {
    background: #5a67d8;
    border-color: #5a67d8;
}

.mode-hint {
    text-align: center;
    font-size: 14px;
    color: #666;
    margin-bottom: 15px;
}

.mode-hint strong {
    color: #667eea;
}

.close-mode {
    width: 100%;
    padding: 10px;
    border: none;
    border-radius: 8px;
    background: #f8f9fa;
    color: #666;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.3s ease;
}

.close-mode:hover {
    background: #e9ecef;
}

/* Стилі для контейнера користувачів */
.users-section {
    min-height: 400px;
    display: flex;
    flex-direction: column;
    gap: 20px;
}

/* Для режиму одного ряду */
.users-section.single-row-mode .users-grid {
    display: flex;
    gap: 12px;
    padding: 10px;
    overflow-x: auto;
    align-items: flex-start;
    flex-wrap: nowrap;
}

.users-section.single-row-mode .user-column {
    min-width: 280px;
    max-width: 320px;
    background: white;
    border-radius: 12px;
    border: 1px solid #e1e5e9;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    flex-shrink: 0;
    transition: transform 0.2s ease;
    overflow: hidden;
}

.users-section.single-row-mode .user-column.collapsed {
    min-width: 120px;
    max-width: 140px;
}

/* Для режиму кількох рядів */
.users-section.multiple-rows-mode .users-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    padding: 10px;
    justify-content: flex-start;
}

.users-section.multiple-rows-mode .user-column {
    min-width: calc(20% - 12px);
    max-width: calc(20% - 12px);
    background: white;
    border-radius: 12px;
    border: 1px solid #e1e5e9;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: transform 0.2s ease;
    overflow: hidden;
}

.users-section.multiple-rows-mode .user-column.collapsed {
    min-width: 80px;
    max-width: 100px;
}

.users-grid-new-row {
    margin-top: 20px;
    padding-top: 20px;
    border-top: 2px solid #e1e5e9;
}

/* Стилі для користувача (загальні) */
.user-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    cursor: pointer;
    min-height: 60px;
    transition: background-color 0.2s;
}

.user-header:hover {
    background: linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%);
}

.user-name {
    font-weight: 600;
    font-size: 15px;
    word-wrap: break-word;
    max-width: 200px;
    line-height: 1.3;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.user-column.collapsed .user-name {
    font-size: 13px;
    max-width: 80px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/* Для положення "bottom" */
.layout-container.bottom-layout {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.layout-container.bottom-layout .users-section {
    order: -1;
}

.layout-container.bottom-layout .general-pool-section {
    order: 1;
    margin-top: 20px;
}

/* Для положень "left" та "right" */
.layout-container.side-layout {
    display: grid;
    gap: 20px;
    align-items: start;
}

.layout-container.left-layout {
    grid-template-columns: 300px 1fr;
}

.layout-container.right-layout {
    grid-template-columns: 1fr 300px;
}

/* Адаптивність для мобільних пристроїв */
@media (max-width: 1024px) {
    .layout-container.side-layout {
        grid-template-columns: 1fr;
    }
    
    .layout-container.side-layout .general-pool-section {
        order: 1;
        margin-top: 20px;
    }
    
    .layout-container.side-layout .users-section {
        order: -1;
    }
    
    .users-section.multiple-rows-mode .user-column {
        min-width: calc(50% - 12px);
        max-width: calc(50% - 12px);
    }
}

@media (max-width: 768px) {
    .users-section.multiple-rows-mode .users-grid {
        justify-content: center;
    }
    
    .users-section.multiple-rows-mode .user-column {
        min-width: 100%;
        max-width: 100%;
    }
    
    .header-controls {
        flex-direction: column;
        gap: 5px;
    }
    
    .display-mode-modal,
    .settings-modal {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 90%;
        max-width: 300px;
    }
}

@media (min-width: 769px) and (max-width: 1200px) {
    .users-section.multiple-rows-mode .user-column {
        min-width: calc(33.333% - 12px);
        max-width: calc(33.333% - 12px);
    }
}
/* MentorsPage.css */
/* Всі стилі обгорнуті селектором .mentors-page, щоб не впливати на інші сторінки */

/* Базові стилі для світлої теми (дефолтні) */
.mentors-page {
    background: #f5f5f5;
    min-height: 100vh;
    transition: background-color 0.3s ease;
}

.mentors-page .mentor-tasks-layout {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 20px;
  }
  
  .mentors-page .columns-row {
    display: flex;
    gap: 20px;
    width: 100%;
  }
  
  .mentors-page .columns-row .mentor-tasks-column {
    flex: 1 1;
    min-width: 0;
  }
  
  .mentors-page .mentor-tasks-column {
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    overflow: hidden;
    display: flex;
    flex-direction: column;
    height: fit-content;
    max-height: 800px;
  }
  
  .mentors-page .column-header {
    padding: 15px 20px;
    color: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-shrink: 0;
  }
  
  .mentors-page .column-header h3 {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    text-shadow: 0 1px 2px rgba(0,0,0,0.2);
  }
  
  .mentors-page .tasks-count {
    background: rgba(255,255,255,0.25);
    padding: 4px 10px;
    border-radius: 20px;
    font-size: 14px;
    font-weight: 600;
    box-shadow: inset 0 1px 3px rgba(0,0,0,0.1);
  }
  
  .mentors-page .tasks-container {
    padding: 15px;
    overflow-y: auto;
    flex: 1 1;
    background: #f8f9fc;
  }
  
  .mentors-page .visible-tasks {
    margin-bottom: 15px;
  }
  
  .mentors-page .hidden-tasks-section {
    border-top: 2px dashed #cbd5e0;
    padding-top: 15px;
    margin-top: 5px;
  }
  
  .mentors-page .hidden-tasks-header {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 12px;
    background: #e9ecef;
    border-radius: 6px;
    cursor: pointer;
    font-size: 14px;
    color: #2d3748;
    font-weight: 500;
    transition: background-color 0.2s;
    border: 1px solid #d0d9e4;
  }
  
  .mentors-page .hidden-tasks-header:hover {
    background: #dee2e6;
  }
  
  .mentors-page .hidden-tasks-icon {
    font-size: 12px;
    color: #4a5568;
  }
  
  .mentors-page .hidden-tasks-title {
    font-weight: 600;
  }
  
  .mentors-page .hidden-tasks-list {
    margin-top: 12px;
  }
  
  .mentors-page .mentor-task-card {
    position: relative;
    background: white;
    border-radius: 8px;
    margin-bottom: 12px;
    padding: 14px;
    overflow: hidden;
    transition: all 0.2s ease;
    border: 1px solid #e2e8f0;
    box-shadow: 0 1px 3px rgba(0,0,0,0.05);
  }
  
  .mentors-page .mentor-task-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 16px rgba(0,0,0,0.1);
    border-color: #cbd5e0;
  }
  
  .mentors-page .mentor-task-card.blocker {
    border-left: 5px solid #f44336;
    background: #fff5f5;
  }
  
  .mentors-page .mentor-task-card.blocker:hover {
    background: #fff0f0;
  }
  
  .mentors-page .task-progress-bar {
    position: absolute;
    top: 0;
    left: 0;
    height: 4px;
    transition: width 1s linear;
    opacity: 0.9;
  }
  
  .mentors-page .task-content {
    position: relative;
    z-index: 1;
  }
  
  .mentors-page .task-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    font-size: 14px;
    color: #4a5568;
    font-weight: 500;
  }
  
  .mentors-page .user-name {
    font-weight: 600;
    color: #1a202c;
    display: flex;
    align-items: center;
    gap: 6px;
  }
  
  .mentors-page .user-name span.role-icon {
    font-size: 16px;
    filter: drop-shadow(0 1px 1px rgba(0,0,0,0.1));
  }
  
  .mentors-page .start-time {
    color: #718096;
    font-weight: 500;
    background: #edf2f7;
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 12px;
  }
  
  .mentors-page .task-name {
    font-weight: 600;
    margin-bottom: 6px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #1a202c;
    font-size: 15px;
  }
  
  .mentors-page .task-project {
    font-size: 13px;
    color: #4a5568;
    margin-bottom: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    background: #edf2f7;
    padding: 4px 8px;
    border-radius: 4px;
    display: inline-block;
    max-width: 100%;
  }
  
  .mentors-page .task-timer {
    font-size: 15px;
    color: #2d3748;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 4px;
    background: #e2e8f0;
    padding: 4px 10px;
    border-radius: 20px;
    width: fit-content;
  }
  
  .mentors-page .task-timer:before {
    content: "⏱️";
    margin-right: 4px;
    font-size: 14px;
  }
  
  .mentors-page .task-link-arrow {
    position: absolute;
    bottom: 14px;
    right: 14px;
    font-size: 20px;
    color: #a0aec0;
    opacity: 0;
    transition: opacity 0.2s, color 0.2s;
    background: white;
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  }
  
  .mentors-page .mentor-task-card:hover .task-link-arrow {
    opacity: 1;
    color: #4299e1;
  }
  
  .mentors-page .no-tasks-message {
    text-align: center;
    color: #718096;
    padding: 30px 20px;
    font-style: italic;
    background: #f7fafc;
    border-radius: 6px;
    border: 1px dashed #cbd5e0;
  }
  
  .mentors-page .show-all-tasks-btn {
    padding: 12px 24px;
    background: #4299e1;
    color: white;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 16px;
    font-weight: 600;
    align-self: center;
    margin: 15px 0 10px;
    min-width: 220px;
    transition: all 0.2s;
    box-shadow: 0 2px 4px rgba(66, 153, 225, 0.3);
    border: 1px solid #3182ce;
  }
  
  .mentors-page .show-all-tasks-btn:hover {
    background: #3182ce;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(66, 153, 225, 0.4);
  }
  
  .mentors-page .show-all-tasks-btn:active {
    transform: translateY(0);
    box-shadow: 0 1px 2px rgba(66, 153, 225, 0.3);
  }
  
  .mentors-page .all-tasks-view {
    margin-top: 25px;
  }
  
  .mentors-page .all-tasks-view h3 {
    margin-bottom: 15px;
    color: #1a202c;
    font-size: 20px;
    font-weight: 600;
    padding-left: 5px;
  }
  
  .mentors-page .users-columns {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
    gap: 20px;
  }
  
  .mentors-page .user-column {
    background: white;
    border-radius: 10px;
    box-shadow: 0 2px 6px rgba(0,0,0,0.08);
    overflow: hidden;
    border: 1px solid #e2e8f0;
  }
  
  .mentors-page .user-header {
    padding: 14px 16px;
    background: #f8fafc;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    border-bottom: 1px solid #e2e8f0;
    transition: background-color 0.2s;
  }
  
  .mentors-page .user-header:hover {
    background: #edf2f7;
  }
  
  .mentors-page .user-header .user-name {
    display: flex;
    align-items: center;
    gap: 10px;
    font-weight: 600;
    color: #1a202c;
    font-size: 15px;
  }
  
  .mentors-page .role-icon {
    font-size: 20px;
    filter: drop-shadow(0 1px 2px rgba(0,0,0,0.1));
  }
  
  .mentors-page .collapse-btn {
    background: white;
    border: 1px solid #cbd5e0;
    cursor: pointer;
    font-size: 14px;
    color: #4a5568;
    padding: 6px 12px;
    border-radius: 20px;
    transition: all 0.2s;
    font-weight: 500;
  }
  
  .mentors-page .collapse-btn:hover {
    background: #e2e8f0;
    border-color: #a0aec0;
  }
  
  .mentors-page .user-column.collapsed .user-header {
    background: #edf2f7;
    border-bottom: none;
  }
  
  .mentors-page .user-statuses {
    padding: 12px;
    background: #ffffff;
  }
  
  .mentors-page .status-section {
    margin-bottom: 12px;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    overflow: hidden;
    background: white;
  }
  
  .mentors-page .status-header {
    padding: 10px 12px;
    background: #f8fafc;
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    font-size: 14px;
    border-bottom: 1px solid #e2e8f0;
    transition: background-color 0.2s;
  }
  
  .mentors-page .status-header:hover {
    background: #edf2f7;
  }
  
  .mentors-page .status-name {
    flex: 1 1;
    font-weight: 600;
  }
  
  .mentors-page .status-name[data-status="В роботі"],
  .mentors-page .status-name[data-status="В работе"],
  .mentors-page .status-name[data-status="In progress"] {
    color: #2563eb;
  }
  
  .mentors-page .status-name[data-status="Черговому"],
  .mentors-page .status-name[data-status="Дежурному"] {
    color: #dd6b20;
  }
  
  .mentors-page .status-name[data-status="В черзі"],
  .mentors-page .status-name[data-status="В очереди"] {
    color: #7b3fe4;
  }
  
  .mentors-page .status-name[data-status="В черзі (м'яч не у нас)"],
  .mentors-page .status-name[data-status="В очереди (мяч не у нас)"] {
    color: #b45309;
  }
  
  .mentors-page .task-count {
    color: #4a5568;
    font-size: 13px;
    font-weight: 500;
    background: #e2e8f0;
    padding: 2px 8px;
    border-radius: 16px;
  }
  
  .mentors-page .collapse-icon {
    font-size: 12px;
    color: #718096;
    margin-left: 4px;
  }
  
  .mentors-page .tasks-list {
    padding: 8px;
    background: white;
  }
  
  .mentors-page .task-item-wrapper {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    border-bottom: 1px solid #f0f4f8;
    font-size: 13px;
    transition: background-color 0.2s;
    background: white;
  }
  
  .mentors-page .task-item-wrapper:hover {
    background: #f8fafc;
  }
  
  .mentors-page .task-item-wrapper:last-child {
    border-bottom: none;
  }
  
  .mentors-page .task-info-compact {
    flex: 1 1;
    min-width: 0;
  }
  
  .mentors-page .task-name-small {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #1a202c;
    font-weight: 500;
    margin-bottom: 4px;
  }
  
  .mentors-page .task-time-small {
    font-size: 12px;
    color: #718096;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 4px;
  }
  
  .mentors-page .task-time-small:before {
    content: "⏱️";
    font-size: 11px;
    opacity: 0.7;
  }
  
  .mentors-page .task-link-small {
    color: #4299e1;
    text-decoration: none;
    font-size: 16px;
    padding: 6px 10px;
    opacity: 0;
    transition: all 0.2s;
    background: #ebf8ff;
    border-radius: 20px;
    font-weight: 600;
  }
  
  .mentors-page .task-item-wrapper:hover .task-link-small {
    opacity: 1;
    color: #2b6cb0;
  }
  
  /* Стилі для скролу */
  .mentors-page .tasks-container::-webkit-scrollbar,
  .mentors-page .tasks-list::-webkit-scrollbar {
    width: 8px;
  }
  
  .mentors-page .tasks-container::-webkit-scrollbar-track,
  .mentors-page .tasks-list::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }
  
  .mentors-page .tasks-container::-webkit-scrollbar-thumb,
  .mentors-page .tasks-list::-webkit-scrollbar-thumb {
    background: #cbd5e0;
    border-radius: 4px;
  }
  
  .mentors-page .tasks-container::-webkit-scrollbar-thumb:hover,
  .mentors-page .tasks-list::-webkit-scrollbar-thumb:hover {
    background: #a0aec0;
  }
  
  /* Стилі для loading та error станів */
  .mentors-page .loading,
  .mentors-page .error {
    text-align: center;
    padding: 40px;
    font-size: 18px;
    color: #4a5568;
  }
  
  .mentors-page .error {
    color: #e53e3e;
  }

/* ============================ */
/* СТИЛІ ДЛЯ ТЕМНОЇ ТЕМИ */
/* ============================ */

/* ФОН СТОРІНКИ */
.mentors-page.dark-theme {
    background-color: #1a202c !important;
}

/* ТЕКСТ ЗАГОЛОВКІВ */
.mentors-page.dark-theme .all-tasks-view h3 {
    color: #ffffff !important;
}

/* КОНТЕЙНЕРИ КОЛОНОК */
.mentors-page.dark-theme .mentor-tasks-column {
    background-color: #414752 !important;
    border-color: #565d6a !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3) !important;
}

.mentors-page.dark-theme .tasks-container {
    background-color: #414752 !important;
}

/* КАРТКИ ЗАДАЧ В ТЕМНІЙ ТЕМІ */
.mentors-page.dark-theme .mentor-task-card {
    background-color: #2d3748 !important;
    border-color: #4a5568 !important;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2) !important;
}

.mentors-page.dark-theme .mentor-task-card:hover {
    background-color: #374151 !important;
    border-color: #6b7280 !important;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3) !important;
}

.mentors-page.dark-theme .mentor-task-card.blocker {
    background: #3d2a2a !important;
    border-left: 5px solid #ef4444 !important;
}

.mentors-page.dark-theme .mentor-task-card.blocker:hover {
    background: #4a3535 !important;
}

/* ТЕКСТ В КАРТКАХ ЗАДАЧ */
.mentors-page.dark-theme .user-name {
    color: #e2e8f0 !important;
}

.mentors-page.dark-theme .start-time {
    background-color: #4a5568 !important;
    color: #cbd5e0 !important;
}

.mentors-page.dark-theme .task-name {
    color: #f7fafc !important;
}

.mentors-page.dark-theme .task-project {
    background-color: #4a5568 !important;
    color: #cbd5e0 !important;
}

.mentors-page.dark-theme .task-timer {
    background-color: #4a5568 !important;
    color: #e2e8f0 !important;
}

.mentors-page.dark-theme .task-link-arrow {
    background-color: #4a5568 !important;
    color: #9ca3af !important;
}

.mentors-page.dark-theme .mentor-task-card:hover .task-link-arrow {
    color: #60a5fa !important;
}

/* ПРИХОВАНІ ЗАДАЧІ */
.mentors-page.dark-theme .hidden-tasks-section {
    border-top-color: #4a5568 !important;
}

.mentors-page.dark-theme .hidden-tasks-header {
    background-color: #4a5568 !important;
    color: #e2e8f0 !important;
    border-color: #6b7280 !important;
}

.mentors-page.dark-theme .hidden-tasks-header:hover {
    background-color: #565d6a !important;
}

.mentors-page.dark-theme .hidden-tasks-icon {
    color: #cbd5e0 !important;
}

/* ПОВІДОМЛЕННЯ */
.mentors-page.dark-theme .no-tasks-message {
    background-color: #374151 !important;
    color: #9ca3af !important;
    border-color: #4a5568 !important;
}

/* КНОПКА ПОКАЗАТИ ВСІ */
.mentors-page.dark-theme .show-all-tasks-btn {
    background: #4a5568 !important;
    border-color: #6b7280 !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3) !important;
}

.mentors-page.dark-theme .show-all-tasks-btn:hover {
    background: #5a6577 !important;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.4) !important;
}

/* КОРИСТУВАЧІ КОЛОНКИ */
.mentors-page.dark-theme .user-column {
    background-color: #414752 !important;
    border-color: #565d6a !important;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3) !important;
}

.mentors-page.dark-theme .user-header {
    background: linear-gradient(135deg, #4a5568 0%, #5a6577 100%) !important;
    border-bottom-color: #6b7280 !important;
}

.mentors-page.dark-theme .user-header:hover {
    background: linear-gradient(135deg, #5a6577 0%, #6b7280 100%) !important;
}

.mentors-page.dark-theme .user-header .user-name {
    color: #ffffff !important;
}

.mentors-page.dark-theme .user-statuses {
    background-color: #414752 !important;
}

/* КНОПКА ЗГОРНУТИ */
.mentors-page.dark-theme .collapse-btn {
    background: rgba(255, 255, 255, 0.2) !important;
    border-color: #6b7280 !important;
    color: #e2e8f0 !important;
}

.mentors-page.dark-theme .collapse-btn:hover {
    background: rgba(255, 255, 255, 0.3) !important;
    border-color: #9ca3af !important;
}

/* СТАТУСИ - залишаються кольоровими як у світлій темі */
.mentors-page.dark-theme .status-section {
    background: white !important;
    border-color: #e2e8f0 !important;
}

.mentors-page.dark-theme .status-header {
    background: #f8fafc !important;
    border-bottom-color: #e2e8f0 !important;
}

.mentors-page.dark-theme .status-header:hover {
    background: #edf2f7 !important;
}

.mentors-page.dark-theme .status-name {
    color: #1a202c !important;
}

.mentors-page.dark-theme .task-count {
    background: #e2e8f0 !important;
    color: #4a5568 !important;
}

.mentors-page.dark-theme .collapse-icon {
    color: #718096 !important;
}

/* СПИСОК ЗАДАЧ */
.mentors-page.dark-theme .tasks-list {
    background: white !important;
}

.mentors-page.dark-theme .task-item-wrapper {
    background: white !important;
    border-bottom-color: #f0f4f8 !important;
}

.mentors-page.dark-theme .task-item-wrapper:hover {
    background: #f8fafc !important;
}

.mentors-page.dark-theme .task-name-small {
    color: #1a202c !important;
}

.mentors-page.dark-theme .task-time-small {
    color: #718096 !important;
}

.mentors-page.dark-theme .task-link-small {
    background: #ebf8ff !important;
    color: #4299e1 !important;
}

.mentors-page.dark-theme .task-item-wrapper:hover .task-link-small {
    color: #2b6cb0 !important;
}

/* СКРОЛ В ТЕМНІЙ ТЕМІ */
.mentors-page.dark-theme .tasks-container::-webkit-scrollbar-track,
.mentors-page.dark-theme .tasks-list::-webkit-scrollbar-track {
    background: #2d3748 !important;
}

.mentors-page.dark-theme .tasks-container::-webkit-scrollbar-thumb,
.mentors-page.dark-theme .tasks-list::-webkit-scrollbar-thumb {
    background: #4a5568 !important;
}

.mentors-page.dark-theme .tasks-container::-webkit-scrollbar-thumb:hover,
.mentors-page.dark-theme .tasks-list::-webkit-scrollbar-thumb:hover {
    background: #6b7280 !important;
}

/* LOADING ТА ERROR */
.mentors-page.dark-theme .loading,
.mentors-page.dark-theme .error {
    color: #e2e8f0 !important;
}

.mentors-page.dark-theme .error {
    color: #f87171 !important;
}`, "",{"version":3,"sources":["webpack://./src/components/covfile/UsersTasksPage.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB,6CAA6C;AAC7C;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,sCAAsC;AAC1C;;AAEA,iCAAiC;AACjC,0BAA0B;AAC1B,iCAAiC;;AAEjC,iBAAiB;AACjB;IACI,oCAAoC;AACxC;;AAEA,qBAAqB;AACrB;;IAEI,yBAAyB;AAC7B;;AAEA,sBAAsB;AACtB;;;;IAII,yBAAyB;AAC7B;;AAEA,wCAAwC;AACxC;IACI,oCAAoC;IACpC,gCAAgC;IAChC,mDAAmD;AACvD;;AAEA;IACI,2BAA2B;IAC3B,oDAAoD;AACxD;;AAEA,+CAA+C;AAC/C;IACI,oCAAoC;AACxC;;AAEA,8BAA8B;AAC9B;IACI,oCAAoC;IACpC,gCAAgC;IAChC,mDAAmD;AACvD;;AAEA,qEAAqE;AACrE;IACI,wEAAwE;IACxE,uBAAuB;AAC3B;;AAEA;IACI,wEAAwE;AAC5E;;AAEA;IACI,6BAA6B;AACjC;;AAEA,gBAAgB;AAChB;IACI,+CAA+C;AACnD;;AAEA,+BAA+B;AAC/B;IACI,+CAA+C;IAC/C,uBAAuB;AAC3B;;AAEA;IACI,+CAA+C;AACnD;;AAEA,iCAAiC;AACjC,yDAAyD;AACzD,iCAAiC;;AAEjC,0CAA0C;AAC1C;IACI,4BAA4B;IAC5B,oCAAoC;IACpC,6BAA6B;IAC7B,oDAAoD;AACxD;;AAEA,4CAA4C;AAC5C;IACI,8BAA8B;IAC9B,2CAA2C;AAC/C;;AAEA;IACI,8BAA8B;AAClC;;AAEA,uCAAuC;AACvC;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA,oDAAoD;AACpD;IACI,8BAA8B;IAC9B,uBAAuB;IACvB,2BAA2B;IAC3B,8BAA8B;IAC9B,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA,2BAA2B;AAC3B;IACI,yBAAyB;AAC7B;;AAEA,qCAAqC;AACrC;IACI,4BAA4B;AAChC;;AAEA,kDAAkD;AAClD;IACI,8BAA8B;IAC9B,2CAA2C;IAC3C,6BAA6B;IAC7B,0BAA0B;AAC9B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;IAC9B,yCAAyC;AAC7C;;AAEA;IACI,8BAA8B;AAClC;;AAEA,sCAAsC;AACtC;IACI,sBAAsB;IACtB,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA,sCAAsC;AACtC;IACI,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA,uDAAuD;AACvD;IACI,2BAA2B;IAC3B,uBAAuB;IACvB,sBAAsB;IACtB,0BAA0B;IAC1B,0BAA0B;AAC9B;;AAEA;IACI,yCAAyC;AAC7C;;AAEA,kCAAkC;AAClC;IACI,oDAAoD;AACxD;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,sBAAsB;IACtB,2BAA2B;IAC3B,mEAAmE;AACvE;;AAEA,iCAAiC;AACjC,qDAAqD;AACrD,iCAAiC;;AAEjC,2BAA2B;AAC3B;;IAEI,oCAAoC;IACpC,yBAAyB;IACzB,oCAAoC;AACxC;;AAEA,qBAAqB;AACrB;;IAEI,oCAAoC;IACpC,yBAAyB;IACzB,oCAAoC;AACxC;;AAEA,wBAAwB;AACxB;;IAEI,oCAAoC;IACpC,yBAAyB;IACzB,oCAAoC;AACxC;;AAEA,oCAAoC;AACpC;;IAEI,oCAAoC;IACpC,yBAAyB;IACzB,oCAAoC;AACxC;;AAEA,uBAAuB;AACvB;;IAEI,oCAAoC;IACpC,yBAAyB;IACzB,oCAAoC;IACpC,wCAAwC;AAC5C;;AAEA,4BAA4B;AAC5B;;IAEI,oCAAoC;IACpC,yBAAyB;IACzB,oCAAoC;IACpC,wCAAwC;AAC5C;;AAEA,uBAAuB;AACvB;;IAEI,oCAAoC;IACpC,yBAAyB;IACzB,oCAAoC;AACxC;;AAEA,iCAAiC;AACjC,8BAA8B;AAC9B,iCAAiC;;AAEjC,oBAAoB;AACpB;IACI,8BAA8B;IAC9B,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;IAChC,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;IAChC,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA,kBAAkB;AAClB;IACI,8BAA8B;IAC9B,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;IAChC,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;IAChC,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA,uBAAuB;AACvB;;IAEI,8BAA8B;IAC9B,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;;IAEI,8BAA8B;IAC9B,gCAAgC;IAChC,uBAAuB;AAC3B;;AAEA,mBAAmB;AACnB;;IAEI,oCAAoC;IACpC,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA,8BAA8B;AAC9B;;IAEI,8BAA8B;IAC9B,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;;IAEI,gCAAgC;IAChC,yBAAyB;AAC7B;;AAEA;;IAEI,gCAAgC;IAChC,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA,mBAAmB;AACnB;;IAEI,8BAA8B;IAC9B,yBAAyB;IACzB,uBAAuB;AAC3B;;AAEA;;IAEI,8BAA8B;AAClC;;AAEA,sBAAsB;AACtB;IACI,8BAA8B;IAC9B,yCAAyC;AAC7C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,6CAA6C;AACjD;;AAEA,iCAAiC;AACjC,8CAA8C;AAC9C,iCAAiC;;AAEjC;IACI,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,aAAa;IACb,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,wCAAwC;IACxC,cAAc;IACd,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,6DAA6D;IAC7D,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,6DAA6D;AACjE;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,yCAAyC;AAC7C;;AAEA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,wCAAwC;IACxC,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,6DAA6D;IAC7D,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,oCAAoC;IACpC,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,iCAAiC;IACjC,cAAc;IACd,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,iCAAiC;IACjC,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,SAAO;IACP,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,iCAAiC;IACjC,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;;IAEI,kBAAkB;IAClB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;AAChB;;AAEA,qBAAqB;AACrB;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,UAAU;AACd;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA,yCAAyC;AACzC;IACI;QACI,0BAA0B;QAC1B,SAAS;IACb;;IAEA;QACI,SAAS;IACb;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,QAAQ;QACR,YAAY;IAChB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA,2BAA2B;AAC3B;;IAEI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;AAC7B;;AAEA,qBAAqB;AACrB;;IAEI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;AAC7B;;AAEA,wBAAwB;AACxB;;IAEI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;AAC7B;;AAEA,oCAAoC;AACpC;;IAEI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;AAC7B;;AAEA,uBAAuB;AACvB;;IAEI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA,4BAA4B;AAC5B;;IAEI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA,uBAAuB;AACvB;;IAEI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,6DAA6D;IAC7D,YAAY;IACZ,0BAA0B;IAC1B,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,oCAAoC;IACpC,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA,sCAAsC;AACtC;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,YAAY;IACZ,+CAA+C;AACnD;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA,4BAA4B;AAC5B;IACI,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,YAAY;IACZ,+CAA+C;AACnD;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA,2CAA2C;AAC3C;IACI,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA,wCAAwC;AACxC;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,cAAc;AAClB;;AAEA,mDAAmD;AACnD;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,6DAA6D;IAC7D,YAAY;IACZ,0BAA0B;IAC1B,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,6DAA6D;IAC7D,+CAA+C;AACnD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,SAAO;AACX;;AAEA;IACI,eAAe;IACf,oCAAoC;IACpC,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA,gCAAgC;AAChC;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,cAAc;IACd,eAAe;IACf,oCAAoC;IACpC,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,kCAAkC;AAClC;IACI,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,aAAa;AACjB;;AAEA,8CAA8C;AAC9C;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA,4CAA4C;AAC5C;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA,kCAAkC;AAClC;IACI;QACI,QAAQ;IACZ;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,WAAW;IACf;;IAEA;QACI,WAAW;QACX,uBAAuB;IAC3B;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,eAAe;IACf,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,wDAAwD;IACxD,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,4BAA4B;AAC5B;IACI;QACI,QAAQ;IACZ;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA,iCAAiC;AACjC;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,YAAY;IACZ,wBAAwB;AAC5B;;AAEA,+BAA+B;AAC/B;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,2CAA2C;IAC3C,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,YAAY;IACZ,+CAA+C;AACnD;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA,+BAA+B;AAC/B;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,yCAAyC;AACzC;IACI;QACI,qCAAqC;IACzC;;IAEA;QACI,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,oBAAoB;IACxB;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;IACb;;IAEA;QACI,WAAW;QACX,8BAA8B;IAClC;;IAEA;QACI,UAAU;QACV,QAAQ;IACZ;AACJ;;AAEA;IACI;QACI,eAAe;QACf,QAAQ;QACR,SAAS;QACT,gCAAgC;QAChC,UAAU;QACV,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,SAAO;QACP,eAAe;IACnB;AACJ;;AAEA,gCAAgC;AAChC;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,yBAAyB;AAC7B;;AAEA;;IAEI,mBAAmB;IACnB,qBAAqB;IACrB,YAAY;IACZ,wBAAwB;AAC5B;;AAEA,uCAAuC;AACvC;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,2CAA2C;IAC3C,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,YAAY;IACZ,+CAA+C;AACnD;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA,sCAAsC;AACtC;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA,2BAA2B;AAC3B;IACI,aAAa;IACb,SAAS;IACT,aAAa;IACb,gBAAgB;IAChB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,wCAAwC;IACxC,cAAc;IACd,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,6BAA6B;AAC7B;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,aAAa;IACb,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;IAC3B,2BAA2B;IAC3B,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,wCAAwC;IACxC,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA,qCAAqC;AACrC;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,6DAA6D;IAC7D,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,6DAA6D;AACjE;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,yCAAyC;AAC7C;;AAEA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA,2BAA2B;AAC3B;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,QAAQ;IACR,gBAAgB;AACpB;;AAEA,mCAAmC;AACnC;IACI,aAAa;IACb,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA,yCAAyC;AACzC;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,QAAQ;QACR,gBAAgB;IACpB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,2BAA2B;QAC3B,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,QAAQ;IACZ;;IAEA;;QAEI,eAAe;QACf,QAAQ;QACR,SAAS;QACT,gCAAgC;QAChC,UAAU;QACV,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,+BAA+B;QAC/B,+BAA+B;IACnC;AACJ;AACA,oBAAoB;AACpB,mFAAmF;;AAEnF,6CAA6C;AAC7C;IACI,mBAAmB;IACnB,iBAAiB;IACjB,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,aAAa;IACb,SAAS;IACT,WAAW;EACb;;EAEA;IACE,SAAO;IACP,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,qCAAqC;IACrC,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,sCAAsC;EACxC;;EAEA;IACE,kCAAkC;IAClC,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,2CAA2C;EAC7C;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,SAAO;IACP,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,8BAA8B;IAC9B,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,iCAAiC;IACjC,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,yBAAyB;IACzB,yBAAyB;IACzB,sCAAsC;EACxC;;EAEA;IACE,2BAA2B;IAC3B,sCAAsC;IACtC,qBAAqB;EACvB;;EAEA;IACE,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,2BAA2B;IAC3B,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,8CAA8C;EAChD;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,cAAc;IACd,UAAU;IACV,oCAAoC;IACpC,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,qCAAqC;EACvC;;EAEA;IACE,UAAU;IACV,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,6CAA6C;IAC7C,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;IACnB,2BAA2B;IAC3B,6CAA6C;EAC/C;;EAEA;IACE,wBAAwB;IACxB,6CAA6C;EAC/C;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,4DAA4D;IAC5D,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,sCAAsC;IACtC,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,gCAAgC;IAChC,iCAAiC;EACnC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,8CAA8C;EAChD;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,eAAe;IACf,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,eAAe;IACf,gCAAgC;IAChC,iCAAiC;EACnC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,SAAO;IACP,gBAAgB;EAClB;;EAEA;;;IAGE,cAAc;EAChB;;EAEA;;IAEE,cAAc;EAChB;;EAEA;;IAEE,cAAc;EAChB;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,gCAAgC;IAChC,eAAe;IACf,iCAAiC;IACjC,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,SAAO;IACP,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,eAAe;IACf,YAAY;EACd;;EAEA;IACE,cAAc;IACd,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,UAAU;IACV,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,cAAc;EAChB;;EAEA,qBAAqB;EACrB;;IAEE,UAAU;EACZ;;EAEA;;IAEE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;;IAEE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA,sCAAsC;EACtC;;IAEE,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;AAEF,iCAAiC;AACjC,0BAA0B;AAC1B,iCAAiC;;AAEjC,iBAAiB;AACjB;IACI,oCAAoC;AACxC;;AAEA,qBAAqB;AACrB;IACI,yBAAyB;AAC7B;;AAEA,uBAAuB;AACvB;IACI,oCAAoC;IACpC,gCAAgC;IAChC,mDAAmD;AACvD;;AAEA;IACI,oCAAoC;AACxC;;AAEA,+BAA+B;AAC/B;IACI,oCAAoC;IACpC,gCAAgC;IAChC,mDAAmD;AACvD;;AAEA;IACI,oCAAoC;IACpC,gCAAgC;IAChC,oDAAoD;AACxD;;AAEA;IACI,8BAA8B;IAC9B,yCAAyC;AAC7C;;AAEA;IACI,8BAA8B;AAClC;;AAEA,0BAA0B;AAC1B;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,qBAAqB;AACrB;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,iBAAiB;AACjB;IACI,oCAAoC;IACpC,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA,wBAAwB;AACxB;IACI,8BAA8B;IAC9B,gCAAgC;IAChC,mDAAmD;AACvD;;AAEA;IACI,8BAA8B;IAC9B,2BAA2B;IAC3B,mDAAmD;AACvD;;AAEA,wBAAwB;AACxB;IACI,oCAAoC;IACpC,gCAAgC;IAChC,mDAAmD;AACvD;;AAEA;IACI,wEAAwE;IACxE,uCAAuC;AAC3C;;AAEA;IACI,wEAAwE;AAC5E;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA,oBAAoB;AACpB;IACI,+CAA+C;IAC/C,gCAAgC;IAChC,yBAAyB;AAC7B;;AAEA;IACI,+CAA+C;IAC/C,gCAAgC;AACpC;;AAEA,wDAAwD;AACxD;IACI,4BAA4B;IAC5B,gCAAgC;AACpC;;AAEA;IACI,8BAA8B;IAC9B,uCAAuC;AAC3C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,iBAAiB;AACjB;IACI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;IAC5B,uCAAuC;AAC3C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,wBAAwB;AACxB;;IAEI,8BAA8B;AAClC;;AAEA;;IAEI,8BAA8B;AAClC;;AAEA;;IAEI,8BAA8B;AAClC;;AAEA,qBAAqB;AACrB;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":["/* UsersTasksPage.css */\r\n/* Базові стилі для світлої теми (дефолтні) */\r\n.users-tasks-page {\r\n    padding: 20px;\r\n    max-width: 100%;\r\n    background: #f5f5f5;\r\n    min-height: 100vh;\r\n    transition: background-color 0.3s ease;\r\n}\r\n\r\n/* ============================ */\r\n/* СТИЛІ ДЛЯ ТЕМНОЇ ТЕМИ */\r\n/* ============================ */\r\n\r\n/* ФОН СТОРІНКИ */\r\n.users-tasks-page.dark-theme {\r\n    background-color: #1a202c !important;\r\n}\r\n\r\n/* ТЕКСТ ЗАГОЛОВКІВ */\r\n.users-tasks-page.dark-theme .page-title,\r\n.users-tasks-page.dark-theme .archive-section h2 {\r\n    color: #ffffff !important;\r\n}\r\n\r\n/* ТЕКСТ ПОВІДОМЛЕНЬ */\r\n.users-tasks-page.dark-theme .no-users,\r\n.users-tasks-page.dark-theme .no-tasks,\r\n.users-tasks-page.dark-theme .loading,\r\n.users-tasks-page.dark-theme .error {\r\n    color: #e2e8f0 !important;\r\n}\r\n\r\n/* КОНТЕЙНЕР КОРИСТУВАЧА - фон #414752 */\r\n.users-tasks-page.dark-theme .user-column {\r\n    background-color: #414752 !important;\r\n    border-color: #565d6a !important;\r\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3) !important;\r\n}\r\n\r\n.users-tasks-page.dark-theme .user-column:hover {\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4) !important;\r\n}\r\n\r\n/* ОБЛАСТЬ СТАТУСІВ КОРИСТУВАЧА - теж #414752 */\r\n.users-tasks-page.dark-theme .user-statuses {\r\n    background-color: #414752 !important;\r\n}\r\n\r\n/* КОНТЕЙНЕР ЗАГАЛЬНОГО ПУЛА */\r\n.users-tasks-page.dark-theme .general-pool-section {\r\n    background-color: #414752 !important;\r\n    border-color: #565d6a !important;\r\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3) !important;\r\n}\r\n\r\n/* ЗАГОЛОВОК КОРИСТУВАЧА - залишається кольоровим як у світлій темі */\r\n.users-tasks-page.dark-theme .user-header {\r\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;\r\n    color: white !important;\r\n}\r\n\r\n.users-tasks-page.dark-theme .user-header:hover {\r\n    background: linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%) !important;\r\n}\r\n\r\n.users-tasks-page.dark-theme .user-column.collapsed .user-header {\r\n    border-radius: 8px !important;\r\n}\r\n\r\n/* ІКОНКА РОЛІ */\r\n.users-tasks-page.dark-theme .role-icon {\r\n    background: rgba(255, 255, 255, 0.2) !important;\r\n}\r\n\r\n/* КНОПКА ЗГОРНУТИ/РОЗГОРНУТИ */\r\n.users-tasks-page.dark-theme .collapse-btn {\r\n    background: rgba(255, 255, 255, 0.2) !important;\r\n    color: white !important;\r\n}\r\n\r\n.users-tasks-page.dark-theme .collapse-btn:hover {\r\n    background: rgba(255, 255, 255, 0.3) !important;\r\n}\r\n\r\n/* ============================ */\r\n/* СТИЛІ ДЛЯ ЗАДАЧ ТА СТАТУСІВ (ЗАЛИШАЮТЬСЯ НЕЗМІННИМИ) */\r\n/* ============================ */\r\n\r\n/* КОНТЕЙНЕР СТАТУСУ - залишається білим */\r\n.users-tasks-page.dark-theme .status-section {\r\n    background: white !important;\r\n    border: 1px solid #e1e5e9 !important;\r\n    border-radius: 8px !important;\r\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05) !important;\r\n}\r\n\r\n/* ЗАГОЛОВОК СТАТУСУ - залишається світлим */\r\n.users-tasks-page.dark-theme .status-header {\r\n    background: #f8f9fa !important;\r\n    border-bottom: 1px solid #e9ecef !important;\r\n}\r\n\r\n.users-tasks-page.dark-theme .status-header:hover {\r\n    background: #e9ecef !important;\r\n}\r\n\r\n/* НАЗВА СТАТУСУ - залишається темною */\r\n.users-tasks-page.dark-theme .status-name {\r\n    color: #495057 !important;\r\n    font-weight: 600 !important;\r\n}\r\n\r\n/* ЛІЧИЛЬНИК ЗАДАЧ - залишається як у світлій темі */\r\n.users-tasks-page.dark-theme .task-count {\r\n    background: #6c757d !important;\r\n    color: white !important;\r\n    padding: 3px 8px !important;\r\n    border-radius: 12px !important;\r\n    font-size: 11px !important;\r\n    font-weight: 600 !important;\r\n}\r\n\r\n/* ІКОНКА ЗГОРНУТИ СТАТУС */\r\n.users-tasks-page.dark-theme .collapse-icon {\r\n    color: #6c757d !important;\r\n}\r\n\r\n/* СПИСОК ЗАДАЧ - залишається білим */\r\n.users-tasks-page.dark-theme .tasks-list {\r\n    background: white !important;\r\n}\r\n\r\n/* КАРТКА ЗАДАЧІ - залишається як у світлій темі */\r\n.users-tasks-page.dark-theme .task-item {\r\n    background: #f8f9fa !important;\r\n    border-bottom: 1px solid #f1f3f4 !important;\r\n    border-radius: 6px !important;\r\n    cursor: pointer !important;\r\n}\r\n\r\n.users-tasks-page.dark-theme .task-item:hover {\r\n    background: #e9ecef !important;\r\n}\r\n\r\n.users-tasks-page.dark-theme .task-item.blocker {\r\n    background: #fff5f5 !important;\r\n    border-left: 4px solid #dc3545 !important;\r\n}\r\n\r\n.users-tasks-page.dark-theme .task-item.expired {\r\n    background: #fff5f5 !important;\r\n}\r\n\r\n/* НАЗВА ЗАДАЧІ - залишається темною */\r\n.users-tasks-page.dark-theme .task-name {\r\n    color: #333 !important;\r\n    font-size: 13px !important;\r\n    font-weight: 500 !important;\r\n}\r\n\r\n/* ПРОЕКТ ЗАДАЧІ - залишається сірим */\r\n.users-tasks-page.dark-theme .task-project {\r\n    color: #666 !important;\r\n    font-size: 0.8em !important;\r\n}\r\n\r\n/* КНОПКА АРХІВУВАННЯ - залишається як у світлій темі */\r\n.users-tasks-page.dark-theme .archive-btn {\r\n    background: none !important;\r\n    border: none !important;\r\n    color: #333 !important;\r\n    font-size: 16px !important;\r\n    cursor: pointer !important;\r\n}\r\n\r\n.users-tasks-page.dark-theme .archive-btn:hover {\r\n    background: rgba(0, 0, 0, 0.1) !important;\r\n}\r\n\r\n/* ТАЙМЕРИ - залишаються темними */\r\n.users-tasks-page.dark-theme .task-times-container {\r\n    border-top: 1px solid rgba(0, 0, 0, 0.05) !important;\r\n}\r\n\r\n.users-tasks-page.dark-theme .planned-time-remaining {\r\n    border-top: 1px dashed rgba(0, 0, 0, 0.1) !important;\r\n}\r\n\r\n.users-tasks-page.dark-theme .time-value {\r\n    color: #333 !important;\r\n    font-weight: 600 !important;\r\n    font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace !important;\r\n}\r\n\r\n/* ============================ */\r\n/* КОЛЬОРИ СТАТУСІВ (ЗАЛИШАЮТЬСЯ ЯК У СВІТЛІЙ ТЕМІ) */\r\n/* ============================ */\r\n\r\n/* Черговому - фіолетовий */\r\n.users-tasks-page.dark-theme .status-name[data-status=\"Черговому\"],\r\n.users-tasks-page.dark-theme .status-name[data-status=\"Дежурному\"] {\r\n    background-color: #e6e6ff !important;\r\n    color: #4d4dff !important;\r\n    border: 1px solid #ccccff !important;\r\n}\r\n\r\n/* В роботі - синій */\r\n.users-tasks-page.dark-theme .status-name[data-status=\"В роботі\"],\r\n.users-tasks-page.dark-theme .status-name[data-status=\"В работе\"] {\r\n    background-color: #e6f2ff !important;\r\n    color: #0066cc !important;\r\n    border: 1px solid #b3d9ff !important;\r\n}\r\n\r\n/* В черзі - оранжевий */\r\n.users-tasks-page.dark-theme .status-name[data-status=\"В черзі\"],\r\n.users-tasks-page.dark-theme .status-name[data-status=\"В очереди\"] {\r\n    background-color: #fff2e6 !important;\r\n    color: #cc6600 !important;\r\n    border: 1px solid #ffd9b3 !important;\r\n}\r\n\r\n/* В черзі (м'яч не у нас) - сірий */\r\n.users-tasks-page.dark-theme .status-name[data-status=\"В черзі (м'яч не у нас)\"],\r\n.users-tasks-page.dark-theme .status-name[data-status=\"В очереди (мяч не у нас)\"] {\r\n    background-color: #d8d1d1 !important;\r\n    color: #756f6f !important;\r\n    border: 1px solid #463f3f !important;\r\n}\r\n\r\n/* Відкладене - сірий */\r\n.users-tasks-page.dark-theme .status-name[data-status=\"Відкладене\"],\r\n.users-tasks-page.dark-theme .status-name[data-status=\"Отложенная\"] {\r\n    background-color: #f2f2f2 !important;\r\n    color: #666666 !important;\r\n    border: 1px solid #d9d9d9 !important;\r\n    text-decoration: line-through !important;\r\n}\r\n\r\n/* Скасоване - темно-сірий */\r\n.users-tasks-page.dark-theme .status-name[data-status=\"Скасоване\"],\r\n.users-tasks-page.dark-theme .status-name[data-status=\"Canceled\"] {\r\n    background-color: #e6e6e6 !important;\r\n    color: #999999 !important;\r\n    border: 1px solid #cccccc !important;\r\n    text-decoration: line-through !important;\r\n}\r\n\r\n/* Виконане - зелений */\r\n.users-tasks-page.dark-theme .status-name[data-status=\"Виконане\"],\r\n.users-tasks-page.dark-theme .status-name[data-status=\"Completed\"] {\r\n    background-color: #e6ffe6 !important;\r\n    color: #009900 !important;\r\n    border: 1px solid #b3ffb3 !important;\r\n}\r\n\r\n/* ============================ */\r\n/* ІНШІ ЕЛЕМЕНТИ ТЕМНОЇ ТЕМИ */\r\n/* ============================ */\r\n\r\n/* КНОПКИ ФІЛЬТРІВ */\r\n.users-tasks-page.dark-theme .filter-btn {\r\n    background: #2d3748 !important;\r\n    border: 2px solid #4a5568 !important;\r\n    color: #a0aec0 !important;\r\n}\r\n\r\n.users-tasks-page.dark-theme .filter-btn:hover {\r\n    border-color: #667eea !important;\r\n    color: #667eea !important;\r\n}\r\n\r\n.users-tasks-page.dark-theme .filter-btn.active {\r\n    border-color: #667eea !important;\r\n    background: #667eea !important;\r\n    color: white !important;\r\n}\r\n\r\n/* КНОПКА АРХІВУ */\r\n.users-tasks-page.dark-theme .archive-toggle-btn {\r\n    background: #2d3748 !important;\r\n    border: 2px solid #4a5568 !important;\r\n    color: #a0aec0 !important;\r\n}\r\n\r\n.users-tasks-page.dark-theme .archive-toggle-btn:hover {\r\n    border-color: #667eea !important;\r\n    color: #667eea !important;\r\n}\r\n\r\n.users-tasks-page.dark-theme .archive-toggle-btn.active {\r\n    border-color: #667eea !important;\r\n    background: #667eea !important;\r\n    color: white !important;\r\n}\r\n\r\n/* КНОПКИ НАЛАШТУВАНЬ */\r\n.users-tasks-page.dark-theme .settings-btn,\r\n.users-tasks-page.dark-theme .display-mode-btn {\r\n    background: #2d3748 !important;\r\n    border: 2px solid #4a5568 !important;\r\n    color: #a0aec0 !important;\r\n}\r\n\r\n.users-tasks-page.dark-theme .settings-btn:hover,\r\n.users-tasks-page.dark-theme .display-mode-btn:hover {\r\n    background: #667eea !important;\r\n    border-color: #667eea !important;\r\n    color: white !important;\r\n}\r\n\r\n/* МОДАЛЬНІ ВІКНА */\r\n.users-tasks-page.dark-theme .settings-modal,\r\n.users-tasks-page.dark-theme .display-mode-modal {\r\n    background-color: #414752 !important;\r\n    border: 1px solid #565d6a !important;\r\n    color: #e2e8f0 !important;\r\n}\r\n\r\n.users-tasks-page.dark-theme .settings-content h3,\r\n.users-tasks-page.dark-theme .display-mode-content h3 {\r\n    color: #ffffff !important;\r\n}\r\n\r\n.users-tasks-page.dark-theme .settings-hint,\r\n.users-tasks-page.dark-theme .mode-hint {\r\n    color: #a0aec0 !important;\r\n}\r\n\r\n.users-tasks-page.dark-theme .settings-hint strong,\r\n.users-tasks-page.dark-theme .mode-hint strong {\r\n    color: #667eea !important;\r\n}\r\n\r\n/* КНОПКИ В МОДАЛЬНИХ ВІКНАХ */\r\n.users-tasks-page.dark-theme .position-btn,\r\n.users-tasks-page.dark-theme .mode-btn {\r\n    background: #2d3748 !important;\r\n    border: 2px solid #4a5568 !important;\r\n    color: #e2e8f0 !important;\r\n}\r\n\r\n.users-tasks-page.dark-theme .position-btn:hover,\r\n.users-tasks-page.dark-theme .mode-btn:hover {\r\n    border-color: #667eea !important;\r\n    color: #667eea !important;\r\n}\r\n\r\n.users-tasks-page.dark-theme .position-btn.active,\r\n.users-tasks-page.dark-theme .mode-btn.active {\r\n    border-color: #667eea !important;\r\n    background: #667eea !important;\r\n    color: white !important;\r\n}\r\n\r\n/* КНОПКИ ЗАКРИТИ */\r\n.users-tasks-page.dark-theme .close-settings,\r\n.users-tasks-page.dark-theme .close-mode {\r\n    background: #2d3748 !important;\r\n    color: #e2e8f0 !important;\r\n    border: none !important;\r\n}\r\n\r\n.users-tasks-page.dark-theme .close-settings:hover,\r\n.users-tasks-page.dark-theme .close-mode:hover {\r\n    background: #4a5568 !important;\r\n}\r\n\r\n/* АРХІВОВАНІ ЗАДАЧІ */\r\n.users-tasks-page.dark-theme .task-item.archived {\r\n    background: #f8f9fa !important;\r\n    border-left: 4px solid #6c757d !important;\r\n}\r\n\r\n.users-tasks-page.dark-theme .task-meta {\r\n    color: #6c757d !important;\r\n}\r\n\r\n.users-tasks-page.dark-theme .restore-btn {\r\n    background: none !important;\r\n    border: none !important;\r\n    color: #333 !important;\r\n}\r\n\r\n.users-tasks-page.dark-theme .restore-btn:hover {\r\n    background: rgba(40, 167, 69, 0.1) !important;\r\n}\r\n\r\n/* ============================ */\r\n/* ОРИГІНАЛЬНІ СТИЛІ СВІТЛОЇ ТЕМИ (БЕЗ ЗМІН) */\r\n/* ============================ */\r\n\r\n.users-tasks-page .page-title {\r\n    text-align: center;\r\n    margin-bottom: 20px;\r\n    color: #333;\r\n    font-size: 24px;\r\n    font-weight: 600;\r\n}\r\n\r\n.users-tasks-page .layout-container {\r\n    display: grid;\r\n    grid-template-columns: 1fr 300px;\r\n    gap: 20px;\r\n    align-items: start;\r\n}\r\n\r\n.users-tasks-page .users-section {\r\n    min-height: 400px;\r\n}\r\n\r\n.users-tasks-page .users-grid {\r\n    display: flex;\r\n    gap: 12px;\r\n    padding: 10px;\r\n    overflow-x: auto;\r\n    align-items: flex-start;\r\n}\r\n\r\n.users-tasks-page .user-column {\r\n    min-width: 280px;\r\n    max-width: 320px;\r\n    background: white;\r\n    border-radius: 12px;\r\n    border: 1px solid #e1e5e9;\r\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n    flex-shrink: 0;\r\n    transition: transform 0.2s ease;\r\n    overflow: hidden;\r\n}\r\n\r\n.users-tasks-page .user-column.collapsed {\r\n    min-width: 120px;\r\n    max-width: 140px;\r\n}\r\n\r\n.users-tasks-page .user-column:hover {\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.users-tasks-page .user-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 15px;\r\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n    color: white;\r\n    cursor: pointer;\r\n    min-height: 60px;\r\n    transition: background-color 0.2s;\r\n}\r\n\r\n.users-tasks-page .user-header:hover {\r\n    background: linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%);\r\n}\r\n\r\n.users-tasks-page .user-column.collapsed .user-header {\r\n    border-radius: 8px;\r\n    min-height: 50px;\r\n    padding: 10px 12px;\r\n}\r\n\r\n.users-tasks-page .user-name {\r\n    font-weight: 600;\r\n    font-size: 15px;\r\n    word-wrap: break-word;\r\n    max-width: 200px;\r\n    line-height: 1.3;\r\n    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.users-tasks-page .user-column.collapsed .user-name {\r\n    font-size: 13px;\r\n    max-width: 80px;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n}\r\n\r\n.users-tasks-page .general-pool-section {\r\n    background: white;\r\n    border-radius: 12px;\r\n    border: 1px solid #e1e5e9;\r\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n    overflow: hidden;\r\n}\r\n\r\n.users-tasks-page .pool-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 15px;\r\n    background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);\r\n    color: white;\r\n    cursor: pointer;\r\n}\r\n\r\n.users-tasks-page .pool-header-left {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n}\r\n\r\n.users-tasks-page .pool-title {\r\n    font-size: 18px;\r\n    font-weight: 600;\r\n    margin: 0;\r\n    color: white;\r\n}\r\n\r\n.users-tasks-page .collapse-btn {\r\n    background: rgba(255, 255, 255, 0.2);\r\n    border: none;\r\n    color: white;\r\n    cursor: pointer;\r\n    font-size: 12px;\r\n    padding: 6px 10px;\r\n    border-radius: 6px;\r\n    transition: background-color 0.2s;\r\n    flex-shrink: 0;\r\n    width: 30px;\r\n    height: 30px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.users-tasks-page .collapse-btn:hover {\r\n    background: rgba(255, 255, 255, 0.3);\r\n}\r\n\r\n.users-tasks-page .user-statuses {\r\n    padding: 12px;\r\n    max-height: 600px;\r\n    overflow-y: auto;\r\n}\r\n\r\n.users-tasks-page .status-section {\r\n    margin-bottom: 12px;\r\n    border: 1px solid #e1e5e9;\r\n    border-radius: 8px;\r\n    overflow: hidden;\r\n    background: white;\r\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.users-tasks-page .status-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 10px 12px;\r\n    background: #f8f9fa;\r\n    cursor: pointer;\r\n    transition: background-color 0.2s;\r\n    font-size: 13px;\r\n    border-bottom: 1px solid #e9ecef;\r\n}\r\n\r\n.users-tasks-page .status-header:hover {\r\n    background: #e9ecef;\r\n}\r\n\r\n.users-tasks-page .status-name {\r\n    font-weight: 600;\r\n    color: #495057;\r\n    flex: 1;\r\n    padding: 4px 8px;\r\n    border-radius: 4px;\r\n    margin-right: 5px;\r\n    font-size: 12px;\r\n    display: inline-block;\r\n}\r\n\r\n.users-tasks-page .task-count {\r\n    background: #6c757d;\r\n    color: white;\r\n    padding: 3px 8px;\r\n    border-radius: 12px;\r\n    font-size: 11px;\r\n    font-weight: 600;\r\n    margin: 0 8px;\r\n    min-width: 24px;\r\n    text-align: center;\r\n}\r\n\r\n.users-tasks-page .collapse-icon {\r\n    font-size: 10px;\r\n    color: #6c757d;\r\n    transition: transform 0.2s;\r\n}\r\n\r\n.users-tasks-page .tasks-list {\r\n    background: white;\r\n    max-height: 300px;\r\n    overflow-y: auto;\r\n}\r\n\r\n.users-tasks-page .general-pool-tasks {\r\n    padding: 15px;\r\n    max-height: 600px;\r\n    overflow-y: auto;\r\n}\r\n\r\n.users-tasks-page .task-item {\r\n    padding: 12px;\r\n    border-bottom: 1px solid #f1f3f4;\r\n    transition: background-color 0.2s;\r\n    position: relative;\r\n    border-radius: 6px;\r\n    margin-bottom: 8px;\r\n    background: #f8f9fa;\r\n    cursor: pointer;\r\n}\r\n\r\n.users-tasks-page .task-item:hover {\r\n    background: #e9ecef;\r\n}\r\n\r\n.users-tasks-page .task-item:last-child {\r\n    border-bottom: none;\r\n    margin-bottom: 0;\r\n}\r\n\r\n.users-tasks-page .task-item.blocker {\r\n    background: #fff5f5;\r\n    border-left: 4px solid #dc3545;\r\n}\r\n\r\n.users-tasks-page .task-name {\r\n    font-size: 13px;\r\n    color: #333;\r\n    margin-bottom: 6px;\r\n    line-height: 1.4;\r\n    word-wrap: break-word;\r\n    font-weight: 500;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n}\r\n\r\n.users-tasks-page .task-project {\r\n    font-size: 0.8em;\r\n    color: #666;\r\n    margin-top: 4px;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n}\r\n\r\n.users-tasks-page .task-time {\r\n    font-size: 11px;\r\n    color: #6c757d;\r\n    background: white;\r\n    padding: 3px 8px;\r\n    border-radius: 6px;\r\n    display: inline-block;\r\n    font-weight: 600;\r\n    border: 1px solid #e9ecef;\r\n}\r\n\r\n.users-tasks-page .task-blocker {\r\n    font-size: 10px;\r\n    color: #dc3545;\r\n    background: #f8d7da;\r\n    padding: 3px 8px;\r\n    border-radius: 6px;\r\n    display: inline-block;\r\n    margin-top: 6px;\r\n    font-weight: 700;\r\n    border: 1px solid #f5c6cb;\r\n}\r\n\r\n.users-tasks-page .loading, \r\n.users-tasks-page .error {\r\n    text-align: center;\r\n    padding: 40px;\r\n    font-size: 18px;\r\n}\r\n\r\n.users-tasks-page .loading {\r\n    color: #007bff;\r\n}\r\n\r\n.users-tasks-page .error {\r\n    color: #dc3545;\r\n}\r\n\r\n.users-tasks-page .no-users, \r\n.users-tasks-page .no-tasks {\r\n    text-align: center;\r\n    padding: 40px;\r\n    color: #6c757d;\r\n    font-size: 16px;\r\n    background: white;\r\n    border-radius: 8px;\r\n    margin: 20px;\r\n}\r\n\r\n/* Стилі для скролу */\r\n.users-tasks-page .users-grid::-webkit-scrollbar {\r\n    height: 8px;\r\n}\r\n\r\n.users-tasks-page .users-grid::-webkit-scrollbar-track {\r\n    background: #f1f1f1;\r\n    border-radius: 4px;\r\n}\r\n\r\n.users-tasks-page .users-grid::-webkit-scrollbar-thumb {\r\n    background: #c1c1c1;\r\n    border-radius: 4px;\r\n}\r\n\r\n.users-tasks-page .users-grid::-webkit-scrollbar-thumb:hover {\r\n    background: #a8a8a8;\r\n}\r\n\r\n.users-tasks-page .tasks-list::-webkit-scrollbar,\r\n.users-tasks-page .general-pool-tasks::-webkit-scrollbar {\r\n    width: 6px;\r\n}\r\n\r\n.users-tasks-page .tasks-list::-webkit-scrollbar-track,\r\n.users-tasks-page .general-pool-tasks::-webkit-scrollbar-track {\r\n    background: #f1f1f1;\r\n}\r\n\r\n.users-tasks-page .tasks-list::-webkit-scrollbar-thumb,\r\n.users-tasks-page .general-pool-tasks::-webkit-scrollbar-thumb {\r\n    background: #d1d1d1;\r\n    border-radius: 3px;\r\n}\r\n\r\n/* Адаптивність для мобільних пристроїв */\r\n@media (max-width: 1024px) {\r\n    .users-tasks-page .layout-container {\r\n        grid-template-columns: 1fr;\r\n        gap: 15px;\r\n    }\r\n    \r\n    .users-tasks-page .general-pool-section {\r\n        order: -1;\r\n    }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .users-tasks-page {\r\n        padding: 10px;\r\n    }\r\n    \r\n    .users-tasks-page .users-grid {\r\n        gap: 8px;\r\n        padding: 5px;\r\n    }\r\n    \r\n    .users-tasks-page .user-column {\r\n        min-width: 260px;\r\n    }\r\n    \r\n    .users-tasks-page .user-column.collapsed {\r\n        min-width: 100px;\r\n        max-width: 120px;\r\n    }\r\n    \r\n    .users-tasks-page .user-name {\r\n        font-size: 14px;\r\n        max-width: 180px;\r\n    }\r\n    \r\n    .users-tasks-page .user-column.collapsed .user-name {\r\n        font-size: 12px;\r\n        max-width: 70px;\r\n    }\r\n    \r\n    .users-tasks-page .user-header {\r\n        padding: 12px;\r\n        min-height: 55px;\r\n    }\r\n    \r\n    .users-tasks-page .user-column.collapsed .user-header {\r\n        min-height: 45px;\r\n        padding: 8px 10px;\r\n    }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n    .users-tasks-page .user-column {\r\n        min-width: 240px;\r\n    }\r\n    \r\n    .users-tasks-page .user-column.collapsed {\r\n        min-width: 90px;\r\n        max-width: 100px;\r\n    }\r\n    \r\n    .users-tasks-page .user-name {\r\n        font-size: 13px;\r\n        max-width: 160px;\r\n    }\r\n    \r\n    .users-tasks-page .user-column.collapsed .user-name {\r\n        font-size: 11px;\r\n        max-width: 60px;\r\n    }\r\n    \r\n    .users-tasks-page .status-header {\r\n        padding: 8px 10px;\r\n        font-size: 12px;\r\n    }\r\n    \r\n    .users-tasks-page .task-item {\r\n        padding: 8px 10px;\r\n    }\r\n    \r\n    .users-tasks-page .task-name {\r\n        font-size: 12px;\r\n    }\r\n    \r\n    .users-tasks-page .page-title {\r\n        font-size: 20px;\r\n    }\r\n}\r\n\r\n.users-tasks-page .page-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.users-tasks-page .archive-toggle-btn {\r\n    background: #007bff;\r\n    color: white;\r\n    border: none;\r\n    padding: 10px 20px;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n}\r\n\r\n.users-tasks-page .archive-toggle-btn.active {\r\n    background: #28a745;\r\n}\r\n\r\n.users-tasks-page .archive-toggle-btn:hover {\r\n    opacity: 0.9;\r\n}\r\n\r\n.users-tasks-page .archive-section {\r\n    margin-top: 20px;\r\n}\r\n\r\n.users-tasks-page .archive-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\r\n    gap: 15px;\r\n    margin-top: 20px;\r\n}\r\n\r\n.users-tasks-page .task-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: flex-start;\r\n    margin-bottom: 5px;\r\n}\r\n\r\n.users-tasks-page .archive-btn, .restore-btn {\r\n    background: none;\r\n    border: none;\r\n    font-size: 16px;\r\n    cursor: pointer;\r\n    padding: 2px 5px;\r\n    border-radius: 3px;\r\n}\r\n\r\n.users-tasks-page .archive-btn:hover {\r\n    background: rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.users-tasks-page .restore-btn:hover {\r\n    background: rgba(40, 167, 69, 0.1);\r\n}\r\n\r\n.users-tasks-page .task-item.archived {\r\n    background: #f8f9fa;\r\n    border-left: 4px solid #6c757d;\r\n}\r\n\r\n.users-tasks-page .task-meta {\r\n    font-size: 12px;\r\n    color: #6c757d;\r\n    margin-top: 5px;\r\n}\r\n\r\n.users-tasks-page .task-meta div {\r\n    margin-bottom: 2px;\r\n}\r\n\r\n/* Черговому - фіолетовий */\r\n.users-tasks-page .status-name[data-status=\"Черговому\"],\r\n.users-tasks-page .status-name[data-status=\"Дежурному\"] {\r\n    background-color: #e6e6ff;\r\n    color: #4d4dff;\r\n    border: 1px solid #ccccff;\r\n}\r\n\r\n/* В роботі - синій */\r\n.users-tasks-page .status-name[data-status=\"В роботі\"],\r\n.users-tasks-page .status-name[data-status=\"В работе\"] {\r\n    background-color: #e6f2ff;\r\n    color: #0066cc;\r\n    border: 1px solid #b3d9ff;\r\n}\r\n\r\n/* В черзі - оранжевий */\r\n.users-tasks-page .status-name[data-status=\"В черзі\"],\r\n.users-tasks-page .status-name[data-status=\"В очереди\"] {\r\n    background-color: #fff2e6;\r\n    color: #cc6600;\r\n    border: 1px solid #ffd9b3;\r\n}\r\n\r\n/* В черзі (м'яч не у нас) - сірий */\r\n.users-tasks-page .status-name[data-status=\"В черзі (м'яч не у нас)\"],\r\n.users-tasks-page .status-name[data-status=\"В очереди (мяч не у нас)\"] {\r\n    background-color: #d8d1d1;\r\n    color: #756f6f;\r\n    border: 1px solid #463f3f;\r\n}\r\n\r\n/* Відкладене - сірий */\r\n.users-tasks-page .status-name[data-status=\"Відкладене\"],\r\n.users-tasks-page .status-name[data-status=\"Отложенная\"] {\r\n    background-color: #f2f2f2;\r\n    color: #666666;\r\n    border: 1px solid #d9d9d9;\r\n    text-decoration: line-through;\r\n}\r\n\r\n/* Скасоване - темно-сірий */\r\n.users-tasks-page .status-name[data-status=\"Скасоване\"],\r\n.users-tasks-page .status-name[data-status=\"Canceled\"] {\r\n    background-color: #e6e6e6;\r\n    color: #999999;\r\n    border: 1px solid #cccccc;\r\n    text-decoration: line-through;\r\n}\r\n\r\n/* Виконане - зелений */\r\n.users-tasks-page .status-name[data-status=\"Виконане\"],\r\n.users-tasks-page .status-name[data-status=\"Completed\"] {\r\n    background-color: #e6ffe6;\r\n    color: #009900;\r\n    border: 1px solid #b3ffb3;\r\n}\r\n\r\n.user-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 10px 15px;\r\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n    color: white;\r\n    border-radius: 8px 8px 0 0;\r\n    cursor: pointer;\r\n    font-weight: bold;\r\n}\r\n\r\n.user-name {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    font-size: 16px;\r\n}\r\n\r\n.role-icon {\r\n    font-size: 18px;\r\n    background: rgba(255, 255, 255, 0.2);\r\n    border-radius: 50%;\r\n    width: 24px;\r\n    height: 24px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.status-header {\r\n    display: flex;\r\n    align-items: center;\r\n    padding: 8px 12px;\r\n    background-color: #f0f0f0;\r\n    border-radius: 4px;\r\n    margin-top: 5px;\r\n    cursor: pointer;\r\n}\r\n\r\n.status-name {\r\n    flex-grow: 1;\r\n    font-weight: 600;\r\n}\r\n\r\n.task-count {\r\n    margin: 0 10px;\r\n    color: #666;\r\n}\r\n\r\n.collapse-icon {\r\n    color: #888;\r\n}\r\n\r\n.user-column.collapsed .user-header {\r\n    border-radius: 8px;\r\n}\r\n\r\n.user-column.collapsed .user-statuses {\r\n    display: none;\r\n}\r\n\r\n/* Стилі для кнопок фільтрації ролей */\r\n.filter-buttons {\r\n    display: flex;\r\n    gap: 10px;\r\n    flex-wrap: wrap;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.filter-btn {\r\n    padding: 8px 12px;\r\n    border: 2px solid #e0e0e0;\r\n    border-radius: 20px;\r\n    background: white;\r\n    color: #666;\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    transition: all 0.3s ease;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 5px;\r\n}\r\n\r\n.filter-btn:hover {\r\n    border-color: #667eea;\r\n    color: #667eea;\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 4px 8px rgba(102, 126, 234, 0.1);\r\n}\r\n\r\n.filter-btn.active {\r\n    border-color: #667eea;\r\n    background: #667eea;\r\n    color: white;\r\n    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);\r\n}\r\n\r\n.filter-btn.active:hover {\r\n    background: #5a67d8;\r\n    border-color: #5a67d8;\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 6px 12px rgba(90, 103, 216, 0.25);\r\n}\r\n\r\n/* Стилі для кнопки архіву */\r\n.archive-toggle-btn {\r\n    padding: 8px 16px;\r\n    border: 2px solid #e0e0e0;\r\n    border-radius: 20px;\r\n    background: white;\r\n    color: #666;\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    transition: all 0.3s ease;\r\n    white-space: nowrap;\r\n}\r\n\r\n.archive-toggle-btn:hover {\r\n    border-color: #667eea;\r\n    color: #667eea;\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 4px 8px rgba(102, 126, 234, 0.1);\r\n}\r\n\r\n.archive-toggle-btn.active {\r\n    border-color: #667eea;\r\n    background: #667eea;\r\n    color: white;\r\n    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);\r\n}\r\n\r\n.archive-toggle-btn.active:hover {\r\n    background: #5a67d8;\r\n    border-color: #5a67d8;\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 6px 12px rgba(90, 103, 216, 0.25);\r\n}\r\n\r\n/* Стилі для кнопки згортання користувача */\r\n.collapse-btn {\r\n    background: none;\r\n    border: none;\r\n    color: white;\r\n    font-size: 12px;\r\n    cursor: pointer;\r\n    padding: 5px;\r\n    border-radius: 4px;\r\n    transition: all 0.2s ease;\r\n    width: 24px;\r\n    height: 24px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.collapse-btn:hover {\r\n    background: rgba(255, 255, 255, 0.2);\r\n    transform: scale(1.1);\r\n}\r\n\r\n/* Стилі для іконки згортання статусів */\r\n.collapse-icon {\r\n    color: #888;\r\n    font-size: 12px;\r\n    margin-left: 5px;\r\n    transition: transform 0.2s ease;\r\n}\r\n\r\n.status-header:hover .collapse-icon {\r\n    color: #667eea;\r\n}\r\n\r\n/* Стилі для заголовка користувача з іконкою ролі */\r\n.user-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 10px 15px;\r\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n    color: white;\r\n    border-radius: 8px 8px 0 0;\r\n    cursor: pointer;\r\n    font-weight: bold;\r\n    min-height: 44px;\r\n    transition: all 0.3s ease;\r\n}\r\n\r\n.user-header:hover {\r\n    background: linear-gradient(135deg, #5a67d8 0%, #6b46a1 100%);\r\n    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);\r\n}\r\n\r\n.user-name {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    font-size: 16px;\r\n    flex: 1;\r\n}\r\n\r\n.role-icon {\r\n    font-size: 18px;\r\n    background: rgba(255, 255, 255, 0.2);\r\n    border-radius: 50%;\r\n    width: 24px;\r\n    height: 24px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    transition: all 0.2s ease;\r\n}\r\n\r\n.user-header:hover .role-icon {\r\n    background: rgba(255, 255, 255, 0.3);\r\n    transform: scale(1.1);\r\n}\r\n\r\n/* Стилі для заголовка статусу */\r\n.status-header {\r\n    display: flex;\r\n    align-items: center;\r\n    padding: 8px 12px;\r\n    background-color: #f8f9fa;\r\n    border-radius: 6px;\r\n    margin-top: 5px;\r\n    cursor: pointer;\r\n    transition: all 0.2s ease;\r\n    border-left: 3px solid transparent;\r\n}\r\n\r\n.status-header:hover {\r\n    background-color: #e9ecef;\r\n    border-left-color: #667eea;\r\n    transform: translateX(2px);\r\n}\r\n\r\n.status-name {\r\n    flex-grow: 1;\r\n    font-weight: 600;\r\n    color: #333;\r\n}\r\n\r\n.task-count {\r\n    margin: 0 10px;\r\n    color: #6c757d;\r\n    font-size: 14px;\r\n    background: rgba(108, 117, 125, 0.1);\r\n    padding: 2px 8px;\r\n    border-radius: 12px;\r\n    font-weight: 500;\r\n}\r\n\r\n/* Анімація для згорнутого стану */\r\n.user-column.collapsed .user-header {\r\n    border-radius: 8px;\r\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.user-column.collapsed .user-statuses {\r\n    display: none;\r\n}\r\n\r\n/* Плавна анімація при згортанні/розгортанні */\r\n.user-statuses {\r\n    transition: all 0.3s ease;\r\n    overflow: hidden;\r\n}\r\n\r\n.status-section {\r\n    transition: all 0.3s ease;\r\n}\r\n\r\n.tasks-list {\r\n    transition: all 0.3s ease;\r\n    overflow: hidden;\r\n}\r\n\r\n/* Стилі для індикатора активності фільтра */\r\n.filter-btn:not(.active) {\r\n    opacity: 0.7;\r\n}\r\n\r\n.filter-btn:not(.active):hover {\r\n    opacity: 1;\r\n}\r\n\r\n/* Медіа-запити для адаптивності */\r\n@media (max-width: 768px) {\r\n    .filter-buttons {\r\n        gap: 5px;\r\n    }\r\n    \r\n    .filter-btn {\r\n        padding: 6px 10px;\r\n        font-size: 13px;\r\n    }\r\n    \r\n    .archive-toggle-btn {\r\n        padding: 6px 12px;\r\n        font-size: 13px;\r\n    }\r\n    \r\n    .header-info {\r\n        flex-direction: column;\r\n        gap: 10px;\r\n    }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n    .filter-buttons {\r\n        flex-direction: column;\r\n        width: 100%;\r\n    }\r\n    \r\n    .filter-btn {\r\n        width: 100%;\r\n        justify-content: center;\r\n    }\r\n}\r\n\r\n.users-tasks-page .task-times-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 2px;\r\n    margin-top: 4px;\r\n    padding: 4px 0;\r\n    border-top: 1px solid rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.users-tasks-page .total-time-in-status {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 100%;\r\n    padding: 2px 0;\r\n}\r\n\r\n.users-tasks-page .planned-time-remaining {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 100%;\r\n    padding: 2px 0;\r\n    border-top: 1px dashed rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.users-tasks-page .time-row {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 100%;\r\n}\r\n\r\n.users-tasks-page .time-value {\r\n    font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;\r\n    font-weight: 600;\r\n    text-align: center;\r\n}\r\n\r\n/* Для мобільних пристроїв */\r\n@media (max-width: 768px) {\r\n    .users-tasks-page .task-times-container {\r\n        gap: 1px;\r\n    }\r\n    \r\n    .users-tasks-page .time-value {\r\n        font-size: 11px;\r\n    }\r\n}\r\n\r\n/* Стилі для кнопки налаштувань */\r\n.page-header-left {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 15px;\r\n    position: relative;\r\n}\r\n\r\n.settings-btn {\r\n    background: #f8f9fa;\r\n    border: 2px solid #e0e0e0;\r\n    border-radius: 50%;\r\n    width: 40px;\r\n    height: 40px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n    font-size: 18px;\r\n    transition: all 0.3s ease;\r\n}\r\n\r\n.settings-btn:hover {\r\n    background: #667eea;\r\n    border-color: #667eea;\r\n    color: white;\r\n    transform: rotate(90deg);\r\n}\r\n\r\n/* Модальне вікно налаштувань */\r\n.settings-modal {\r\n    position: absolute;\r\n    top: 100%;\r\n    left: 0;\r\n    z-index: 1000;\r\n    background: white;\r\n    border-radius: 12px;\r\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);\r\n    min-width: 280px;\r\n    margin-top: 10px;\r\n    border: 1px solid #e0e0e0;\r\n    overflow: hidden;\r\n}\r\n\r\n.settings-content {\r\n    padding: 20px;\r\n}\r\n\r\n.settings-content h3 {\r\n    margin: 0 0 15px 0;\r\n    color: #333;\r\n    font-size: 16px;\r\n    text-align: center;\r\n}\r\n\r\n.position-options {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 10px;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.position-btn {\r\n    padding: 12px 20px;\r\n    border: 2px solid #e0e0e0;\r\n    border-radius: 8px;\r\n    background: white;\r\n    color: #666;\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    transition: all 0.3s ease;\r\n    text-align: center;\r\n}\r\n\r\n.position-btn:hover {\r\n    border-color: #667eea;\r\n    color: #667eea;\r\n    transform: translateY(-2px);\r\n}\r\n\r\n.position-btn.active {\r\n    border-color: #667eea;\r\n    background: #667eea;\r\n    color: white;\r\n    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);\r\n}\r\n\r\n.position-btn.active:hover {\r\n    background: #5a67d8;\r\n    border-color: #5a67d8;\r\n}\r\n\r\n.settings-hint {\r\n    text-align: center;\r\n    font-size: 14px;\r\n    color: #666;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.settings-hint strong {\r\n    color: #667eea;\r\n}\r\n\r\n.close-settings {\r\n    width: 100%;\r\n    padding: 10px;\r\n    border: none;\r\n    border-radius: 8px;\r\n    background: #f8f9fa;\r\n    color: #666;\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n    transition: all 0.3s ease;\r\n}\r\n\r\n.close-settings:hover {\r\n    background: #e9ecef;\r\n}\r\n\r\n/* Стилі для компонента внизу */\r\n.general-pool-section.bottom {\r\n    grid-column: 1 / -1;\r\n    margin-top: 20px;\r\n}\r\n\r\n/* Адаптивність для мобільних пристроїв */\r\n@media (max-width: 1024px) {\r\n    .layout-container {\r\n        grid-template-columns: 1fr !important;\r\n    }\r\n    \r\n    .general-pool-section {\r\n        order: 1 !important;\r\n        margin-top: 20px;\r\n    }\r\n    \r\n    .users-section {\r\n        order: -1 !important;\r\n    }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .page-header {\r\n        flex-direction: column;\r\n        align-items: flex-start;\r\n        gap: 15px;\r\n    }\r\n    \r\n    .page-header-left {\r\n        width: 100%;\r\n        justify-content: space-between;\r\n    }\r\n    \r\n    .settings-modal {\r\n        left: auto;\r\n        right: 0;\r\n    }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n    .settings-modal {\r\n        position: fixed;\r\n        top: 50%;\r\n        left: 50%;\r\n        transform: translate(-50%, -50%);\r\n        width: 90%;\r\n        max-width: 300px;\r\n    }\r\n    \r\n    .position-options {\r\n        flex-direction: row;\r\n        flex-wrap: wrap;\r\n    }\r\n    \r\n    .position-btn {\r\n        flex: 1;\r\n        min-width: 80px;\r\n    }\r\n}\r\n\r\n/* Стилі для кнопок управління */\r\n.header-controls {\r\n    display: flex;\r\n    gap: 10px;\r\n    align-items: center;\r\n}\r\n\r\n.display-mode-btn,\r\n.settings-btn {\r\n    background: #f8f9fa;\r\n    border: 2px solid #e0e0e0;\r\n    border-radius: 50%;\r\n    width: 40px;\r\n    height: 40px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n    font-size: 18px;\r\n    transition: all 0.3s ease;\r\n}\r\n\r\n.display-mode-btn:hover,\r\n.settings-btn:hover {\r\n    background: #667eea;\r\n    border-color: #667eea;\r\n    color: white;\r\n    transform: rotate(90deg);\r\n}\r\n\r\n/* Модальне вікно режиму відображення */\r\n.display-mode-modal {\r\n    position: absolute;\r\n    top: 100%;\r\n    left: 0;\r\n    z-index: 1001;\r\n    background: white;\r\n    border-radius: 12px;\r\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);\r\n    min-width: 280px;\r\n    margin-top: 10px;\r\n    border: 1px solid #e0e0e0;\r\n    overflow: hidden;\r\n}\r\n\r\n.display-mode-content {\r\n    padding: 20px;\r\n}\r\n\r\n.display-mode-content h3 {\r\n    margin: 0 0 15px 0;\r\n    color: #333;\r\n    font-size: 16px;\r\n    text-align: center;\r\n}\r\n\r\n.mode-options {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 10px;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.mode-btn {\r\n    padding: 12px 20px;\r\n    border: 2px solid #e0e0e0;\r\n    border-radius: 8px;\r\n    background: white;\r\n    color: #666;\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    transition: all 0.3s ease;\r\n    text-align: center;\r\n}\r\n\r\n.mode-btn:hover {\r\n    border-color: #667eea;\r\n    color: #667eea;\r\n    transform: translateY(-2px);\r\n}\r\n\r\n.mode-btn.active {\r\n    border-color: #667eea;\r\n    background: #667eea;\r\n    color: white;\r\n    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);\r\n}\r\n\r\n.mode-btn.active:hover {\r\n    background: #5a67d8;\r\n    border-color: #5a67d8;\r\n}\r\n\r\n.mode-hint {\r\n    text-align: center;\r\n    font-size: 14px;\r\n    color: #666;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.mode-hint strong {\r\n    color: #667eea;\r\n}\r\n\r\n.close-mode {\r\n    width: 100%;\r\n    padding: 10px;\r\n    border: none;\r\n    border-radius: 8px;\r\n    background: #f8f9fa;\r\n    color: #666;\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n    transition: all 0.3s ease;\r\n}\r\n\r\n.close-mode:hover {\r\n    background: #e9ecef;\r\n}\r\n\r\n/* Стилі для контейнера користувачів */\r\n.users-section {\r\n    min-height: 400px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 20px;\r\n}\r\n\r\n/* Для режиму одного ряду */\r\n.users-section.single-row-mode .users-grid {\r\n    display: flex;\r\n    gap: 12px;\r\n    padding: 10px;\r\n    overflow-x: auto;\r\n    align-items: flex-start;\r\n    flex-wrap: nowrap;\r\n}\r\n\r\n.users-section.single-row-mode .user-column {\r\n    min-width: 280px;\r\n    max-width: 320px;\r\n    background: white;\r\n    border-radius: 12px;\r\n    border: 1px solid #e1e5e9;\r\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n    flex-shrink: 0;\r\n    transition: transform 0.2s ease;\r\n    overflow: hidden;\r\n}\r\n\r\n.users-section.single-row-mode .user-column.collapsed {\r\n    min-width: 120px;\r\n    max-width: 140px;\r\n}\r\n\r\n/* Для режиму кількох рядів */\r\n.users-section.multiple-rows-mode .users-grid {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    gap: 12px;\r\n    padding: 10px;\r\n    justify-content: flex-start;\r\n}\r\n\r\n.users-section.multiple-rows-mode .user-column {\r\n    min-width: calc(20% - 12px);\r\n    max-width: calc(20% - 12px);\r\n    background: white;\r\n    border-radius: 12px;\r\n    border: 1px solid #e1e5e9;\r\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n    transition: transform 0.2s ease;\r\n    overflow: hidden;\r\n}\r\n\r\n.users-section.multiple-rows-mode .user-column.collapsed {\r\n    min-width: 80px;\r\n    max-width: 100px;\r\n}\r\n\r\n.users-grid-new-row {\r\n    margin-top: 20px;\r\n    padding-top: 20px;\r\n    border-top: 2px solid #e1e5e9;\r\n}\r\n\r\n/* Стилі для користувача (загальні) */\r\n.user-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 15px;\r\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n    color: white;\r\n    cursor: pointer;\r\n    min-height: 60px;\r\n    transition: background-color 0.2s;\r\n}\r\n\r\n.user-header:hover {\r\n    background: linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%);\r\n}\r\n\r\n.user-name {\r\n    font-weight: 600;\r\n    font-size: 15px;\r\n    word-wrap: break-word;\r\n    max-width: 200px;\r\n    line-height: 1.3;\r\n    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.user-column.collapsed .user-name {\r\n    font-size: 13px;\r\n    max-width: 80px;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n}\r\n\r\n/* Для положення \"bottom\" */\r\n.layout-container.bottom-layout {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 20px;\r\n}\r\n\r\n.layout-container.bottom-layout .users-section {\r\n    order: -1;\r\n}\r\n\r\n.layout-container.bottom-layout .general-pool-section {\r\n    order: 1;\r\n    margin-top: 20px;\r\n}\r\n\r\n/* Для положень \"left\" та \"right\" */\r\n.layout-container.side-layout {\r\n    display: grid;\r\n    gap: 20px;\r\n    align-items: start;\r\n}\r\n\r\n.layout-container.left-layout {\r\n    grid-template-columns: 300px 1fr;\r\n}\r\n\r\n.layout-container.right-layout {\r\n    grid-template-columns: 1fr 300px;\r\n}\r\n\r\n/* Адаптивність для мобільних пристроїв */\r\n@media (max-width: 1024px) {\r\n    .layout-container.side-layout {\r\n        grid-template-columns: 1fr;\r\n    }\r\n    \r\n    .layout-container.side-layout .general-pool-section {\r\n        order: 1;\r\n        margin-top: 20px;\r\n    }\r\n    \r\n    .layout-container.side-layout .users-section {\r\n        order: -1;\r\n    }\r\n    \r\n    .users-section.multiple-rows-mode .user-column {\r\n        min-width: calc(50% - 12px);\r\n        max-width: calc(50% - 12px);\r\n    }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .users-section.multiple-rows-mode .users-grid {\r\n        justify-content: center;\r\n    }\r\n    \r\n    .users-section.multiple-rows-mode .user-column {\r\n        min-width: 100%;\r\n        max-width: 100%;\r\n    }\r\n    \r\n    .header-controls {\r\n        flex-direction: column;\r\n        gap: 5px;\r\n    }\r\n    \r\n    .display-mode-modal,\r\n    .settings-modal {\r\n        position: fixed;\r\n        top: 50%;\r\n        left: 50%;\r\n        transform: translate(-50%, -50%);\r\n        width: 90%;\r\n        max-width: 300px;\r\n    }\r\n}\r\n\r\n@media (min-width: 769px) and (max-width: 1200px) {\r\n    .users-section.multiple-rows-mode .user-column {\r\n        min-width: calc(33.333% - 12px);\r\n        max-width: calc(33.333% - 12px);\r\n    }\r\n}\r\n/* MentorsPage.css */\r\n/* Всі стилі обгорнуті селектором .mentors-page, щоб не впливати на інші сторінки */\r\n\r\n/* Базові стилі для світлої теми (дефолтні) */\r\n.mentors-page {\r\n    background: #f5f5f5;\r\n    min-height: 100vh;\r\n    transition: background-color 0.3s ease;\r\n}\r\n\r\n.mentors-page .mentor-tasks-layout {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 20px;\r\n    padding: 20px;\r\n  }\r\n  \r\n  .mentors-page .columns-row {\r\n    display: flex;\r\n    gap: 20px;\r\n    width: 100%;\r\n  }\r\n  \r\n  .mentors-page .columns-row .mentor-tasks-column {\r\n    flex: 1;\r\n    min-width: 0;\r\n  }\r\n  \r\n  .mentors-page .mentor-tasks-column {\r\n    background: white;\r\n    border-radius: 8px;\r\n    box-shadow: 0 2px 8px rgba(0,0,0,0.1);\r\n    overflow: hidden;\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: fit-content;\r\n    max-height: 800px;\r\n  }\r\n  \r\n  .mentors-page .column-header {\r\n    padding: 15px 20px;\r\n    color: white;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    flex-shrink: 0;\r\n  }\r\n  \r\n  .mentors-page .column-header h3 {\r\n    margin: 0;\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n    text-shadow: 0 1px 2px rgba(0,0,0,0.2);\r\n  }\r\n  \r\n  .mentors-page .tasks-count {\r\n    background: rgba(255,255,255,0.25);\r\n    padding: 4px 10px;\r\n    border-radius: 20px;\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n    box-shadow: inset 0 1px 3px rgba(0,0,0,0.1);\r\n  }\r\n  \r\n  .mentors-page .tasks-container {\r\n    padding: 15px;\r\n    overflow-y: auto;\r\n    flex: 1;\r\n    background: #f8f9fc;\r\n  }\r\n  \r\n  .mentors-page .visible-tasks {\r\n    margin-bottom: 15px;\r\n  }\r\n  \r\n  .mentors-page .hidden-tasks-section {\r\n    border-top: 2px dashed #cbd5e0;\r\n    padding-top: 15px;\r\n    margin-top: 5px;\r\n  }\r\n  \r\n  .mentors-page .hidden-tasks-header {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    padding: 10px 12px;\r\n    background: #e9ecef;\r\n    border-radius: 6px;\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n    color: #2d3748;\r\n    font-weight: 500;\r\n    transition: background-color 0.2s;\r\n    border: 1px solid #d0d9e4;\r\n  }\r\n  \r\n  .mentors-page .hidden-tasks-header:hover {\r\n    background: #dee2e6;\r\n  }\r\n  \r\n  .mentors-page .hidden-tasks-icon {\r\n    font-size: 12px;\r\n    color: #4a5568;\r\n  }\r\n  \r\n  .mentors-page .hidden-tasks-title {\r\n    font-weight: 600;\r\n  }\r\n  \r\n  .mentors-page .hidden-tasks-list {\r\n    margin-top: 12px;\r\n  }\r\n  \r\n  .mentors-page .mentor-task-card {\r\n    position: relative;\r\n    background: white;\r\n    border-radius: 8px;\r\n    margin-bottom: 12px;\r\n    padding: 14px;\r\n    overflow: hidden;\r\n    transition: all 0.2s ease;\r\n    border: 1px solid #e2e8f0;\r\n    box-shadow: 0 1px 3px rgba(0,0,0,0.05);\r\n  }\r\n  \r\n  .mentors-page .mentor-task-card:hover {\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 8px 16px rgba(0,0,0,0.1);\r\n    border-color: #cbd5e0;\r\n  }\r\n  \r\n  .mentors-page .mentor-task-card.blocker {\r\n    border-left: 5px solid #f44336;\r\n    background: #fff5f5;\r\n  }\r\n  \r\n  .mentors-page .mentor-task-card.blocker:hover {\r\n    background: #fff0f0;\r\n  }\r\n  \r\n  .mentors-page .task-progress-bar {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    height: 4px;\r\n    transition: width 1s linear;\r\n    opacity: 0.9;\r\n  }\r\n  \r\n  .mentors-page .task-content {\r\n    position: relative;\r\n    z-index: 1;\r\n  }\r\n  \r\n  .mentors-page .task-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    margin-bottom: 10px;\r\n    font-size: 14px;\r\n    color: #4a5568;\r\n    font-weight: 500;\r\n  }\r\n  \r\n  .mentors-page .user-name {\r\n    font-weight: 600;\r\n    color: #1a202c;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n  }\r\n  \r\n  .mentors-page .user-name span.role-icon {\r\n    font-size: 16px;\r\n    filter: drop-shadow(0 1px 1px rgba(0,0,0,0.1));\r\n  }\r\n  \r\n  .mentors-page .start-time {\r\n    color: #718096;\r\n    font-weight: 500;\r\n    background: #edf2f7;\r\n    padding: 2px 8px;\r\n    border-radius: 12px;\r\n    font-size: 12px;\r\n  }\r\n  \r\n  .mentors-page .task-name {\r\n    font-weight: 600;\r\n    margin-bottom: 6px;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    color: #1a202c;\r\n    font-size: 15px;\r\n  }\r\n  \r\n  .mentors-page .task-project {\r\n    font-size: 13px;\r\n    color: #4a5568;\r\n    margin-bottom: 10px;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    background: #edf2f7;\r\n    padding: 4px 8px;\r\n    border-radius: 4px;\r\n    display: inline-block;\r\n    max-width: 100%;\r\n  }\r\n  \r\n  .mentors-page .task-timer {\r\n    font-size: 15px;\r\n    color: #2d3748;\r\n    font-weight: 600;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 4px;\r\n    background: #e2e8f0;\r\n    padding: 4px 10px;\r\n    border-radius: 20px;\r\n    width: fit-content;\r\n  }\r\n  \r\n  .mentors-page .task-timer:before {\r\n    content: \"⏱️\";\r\n    margin-right: 4px;\r\n    font-size: 14px;\r\n  }\r\n  \r\n  .mentors-page .task-link-arrow {\r\n    position: absolute;\r\n    bottom: 14px;\r\n    right: 14px;\r\n    font-size: 20px;\r\n    color: #a0aec0;\r\n    opacity: 0;\r\n    transition: opacity 0.2s, color 0.2s;\r\n    background: white;\r\n    width: 28px;\r\n    height: 28px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border-radius: 50%;\r\n    box-shadow: 0 2px 4px rgba(0,0,0,0.1);\r\n  }\r\n  \r\n  .mentors-page .mentor-task-card:hover .task-link-arrow {\r\n    opacity: 1;\r\n    color: #4299e1;\r\n  }\r\n  \r\n  .mentors-page .no-tasks-message {\r\n    text-align: center;\r\n    color: #718096;\r\n    padding: 30px 20px;\r\n    font-style: italic;\r\n    background: #f7fafc;\r\n    border-radius: 6px;\r\n    border: 1px dashed #cbd5e0;\r\n  }\r\n  \r\n  .mentors-page .show-all-tasks-btn {\r\n    padding: 12px 24px;\r\n    background: #4299e1;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 8px;\r\n    cursor: pointer;\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n    align-self: center;\r\n    margin: 15px 0 10px;\r\n    min-width: 220px;\r\n    transition: all 0.2s;\r\n    box-shadow: 0 2px 4px rgba(66, 153, 225, 0.3);\r\n    border: 1px solid #3182ce;\r\n  }\r\n  \r\n  .mentors-page .show-all-tasks-btn:hover {\r\n    background: #3182ce;\r\n    transform: translateY(-1px);\r\n    box-shadow: 0 4px 8px rgba(66, 153, 225, 0.4);\r\n  }\r\n  \r\n  .mentors-page .show-all-tasks-btn:active {\r\n    transform: translateY(0);\r\n    box-shadow: 0 1px 2px rgba(66, 153, 225, 0.3);\r\n  }\r\n  \r\n  .mentors-page .all-tasks-view {\r\n    margin-top: 25px;\r\n  }\r\n  \r\n  .mentors-page .all-tasks-view h3 {\r\n    margin-bottom: 15px;\r\n    color: #1a202c;\r\n    font-size: 20px;\r\n    font-weight: 600;\r\n    padding-left: 5px;\r\n  }\r\n  \r\n  .mentors-page .users-columns {\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\r\n    gap: 20px;\r\n  }\r\n  \r\n  .mentors-page .user-column {\r\n    background: white;\r\n    border-radius: 10px;\r\n    box-shadow: 0 2px 6px rgba(0,0,0,0.08);\r\n    overflow: hidden;\r\n    border: 1px solid #e2e8f0;\r\n  }\r\n  \r\n  .mentors-page .user-header {\r\n    padding: 14px 16px;\r\n    background: #f8fafc;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    cursor: pointer;\r\n    border-bottom: 1px solid #e2e8f0;\r\n    transition: background-color 0.2s;\r\n  }\r\n  \r\n  .mentors-page .user-header:hover {\r\n    background: #edf2f7;\r\n  }\r\n  \r\n  .mentors-page .user-header .user-name {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n    font-weight: 600;\r\n    color: #1a202c;\r\n    font-size: 15px;\r\n  }\r\n  \r\n  .mentors-page .role-icon {\r\n    font-size: 20px;\r\n    filter: drop-shadow(0 1px 2px rgba(0,0,0,0.1));\r\n  }\r\n  \r\n  .mentors-page .collapse-btn {\r\n    background: white;\r\n    border: 1px solid #cbd5e0;\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n    color: #4a5568;\r\n    padding: 6px 12px;\r\n    border-radius: 20px;\r\n    transition: all 0.2s;\r\n    font-weight: 500;\r\n  }\r\n  \r\n  .mentors-page .collapse-btn:hover {\r\n    background: #e2e8f0;\r\n    border-color: #a0aec0;\r\n  }\r\n  \r\n  .mentors-page .user-column.collapsed .user-header {\r\n    background: #edf2f7;\r\n    border-bottom: none;\r\n  }\r\n  \r\n  .mentors-page .user-statuses {\r\n    padding: 12px;\r\n    background: #ffffff;\r\n  }\r\n  \r\n  .mentors-page .status-section {\r\n    margin-bottom: 12px;\r\n    border: 1px solid #e2e8f0;\r\n    border-radius: 8px;\r\n    overflow: hidden;\r\n    background: white;\r\n  }\r\n  \r\n  .mentors-page .status-header {\r\n    padding: 10px 12px;\r\n    background: #f8fafc;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n    border-bottom: 1px solid #e2e8f0;\r\n    transition: background-color 0.2s;\r\n  }\r\n  \r\n  .mentors-page .status-header:hover {\r\n    background: #edf2f7;\r\n  }\r\n  \r\n  .mentors-page .status-name {\r\n    flex: 1;\r\n    font-weight: 600;\r\n  }\r\n  \r\n  .mentors-page .status-name[data-status=\"В роботі\"],\r\n  .mentors-page .status-name[data-status=\"В работе\"],\r\n  .mentors-page .status-name[data-status=\"In progress\"] {\r\n    color: #2563eb;\r\n  }\r\n  \r\n  .mentors-page .status-name[data-status=\"Черговому\"],\r\n  .mentors-page .status-name[data-status=\"Дежурному\"] {\r\n    color: #dd6b20;\r\n  }\r\n  \r\n  .mentors-page .status-name[data-status=\"В черзі\"],\r\n  .mentors-page .status-name[data-status=\"В очереди\"] {\r\n    color: #7b3fe4;\r\n  }\r\n  \r\n  .mentors-page .status-name[data-status=\"В черзі (м'яч не у нас)\"],\r\n  .mentors-page .status-name[data-status=\"В очереди (мяч не у нас)\"] {\r\n    color: #b45309;\r\n  }\r\n  \r\n  .mentors-page .task-count {\r\n    color: #4a5568;\r\n    font-size: 13px;\r\n    font-weight: 500;\r\n    background: #e2e8f0;\r\n    padding: 2px 8px;\r\n    border-radius: 16px;\r\n  }\r\n  \r\n  .mentors-page .collapse-icon {\r\n    font-size: 12px;\r\n    color: #718096;\r\n    margin-left: 4px;\r\n  }\r\n  \r\n  .mentors-page .tasks-list {\r\n    padding: 8px;\r\n    background: white;\r\n  }\r\n  \r\n  .mentors-page .task-item-wrapper {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n    padding: 10px 12px;\r\n    border-bottom: 1px solid #f0f4f8;\r\n    font-size: 13px;\r\n    transition: background-color 0.2s;\r\n    background: white;\r\n  }\r\n  \r\n  .mentors-page .task-item-wrapper:hover {\r\n    background: #f8fafc;\r\n  }\r\n  \r\n  .mentors-page .task-item-wrapper:last-child {\r\n    border-bottom: none;\r\n  }\r\n  \r\n  .mentors-page .task-info-compact {\r\n    flex: 1;\r\n    min-width: 0;\r\n  }\r\n  \r\n  .mentors-page .task-name-small {\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    color: #1a202c;\r\n    font-weight: 500;\r\n    margin-bottom: 4px;\r\n  }\r\n  \r\n  .mentors-page .task-time-small {\r\n    font-size: 12px;\r\n    color: #718096;\r\n    font-weight: 500;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 4px;\r\n  }\r\n  \r\n  .mentors-page .task-time-small:before {\r\n    content: \"⏱️\";\r\n    font-size: 11px;\r\n    opacity: 0.7;\r\n  }\r\n  \r\n  .mentors-page .task-link-small {\r\n    color: #4299e1;\r\n    text-decoration: none;\r\n    font-size: 16px;\r\n    padding: 6px 10px;\r\n    opacity: 0;\r\n    transition: all 0.2s;\r\n    background: #ebf8ff;\r\n    border-radius: 20px;\r\n    font-weight: 600;\r\n  }\r\n  \r\n  .mentors-page .task-item-wrapper:hover .task-link-small {\r\n    opacity: 1;\r\n    color: #2b6cb0;\r\n  }\r\n  \r\n  /* Стилі для скролу */\r\n  .mentors-page .tasks-container::-webkit-scrollbar,\r\n  .mentors-page .tasks-list::-webkit-scrollbar {\r\n    width: 8px;\r\n  }\r\n  \r\n  .mentors-page .tasks-container::-webkit-scrollbar-track,\r\n  .mentors-page .tasks-list::-webkit-scrollbar-track {\r\n    background: #f1f1f1;\r\n    border-radius: 4px;\r\n  }\r\n  \r\n  .mentors-page .tasks-container::-webkit-scrollbar-thumb,\r\n  .mentors-page .tasks-list::-webkit-scrollbar-thumb {\r\n    background: #cbd5e0;\r\n    border-radius: 4px;\r\n  }\r\n  \r\n  .mentors-page .tasks-container::-webkit-scrollbar-thumb:hover,\r\n  .mentors-page .tasks-list::-webkit-scrollbar-thumb:hover {\r\n    background: #a0aec0;\r\n  }\r\n  \r\n  /* Стилі для loading та error станів */\r\n  .mentors-page .loading,\r\n  .mentors-page .error {\r\n    text-align: center;\r\n    padding: 40px;\r\n    font-size: 18px;\r\n    color: #4a5568;\r\n  }\r\n  \r\n  .mentors-page .error {\r\n    color: #e53e3e;\r\n  }\r\n\r\n/* ============================ */\r\n/* СТИЛІ ДЛЯ ТЕМНОЇ ТЕМИ */\r\n/* ============================ */\r\n\r\n/* ФОН СТОРІНКИ */\r\n.mentors-page.dark-theme {\r\n    background-color: #1a202c !important;\r\n}\r\n\r\n/* ТЕКСТ ЗАГОЛОВКІВ */\r\n.mentors-page.dark-theme .all-tasks-view h3 {\r\n    color: #ffffff !important;\r\n}\r\n\r\n/* КОНТЕЙНЕРИ КОЛОНОК */\r\n.mentors-page.dark-theme .mentor-tasks-column {\r\n    background-color: #414752 !important;\r\n    border-color: #565d6a !important;\r\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3) !important;\r\n}\r\n\r\n.mentors-page.dark-theme .tasks-container {\r\n    background-color: #414752 !important;\r\n}\r\n\r\n/* КАРТКИ ЗАДАЧ В ТЕМНІЙ ТЕМІ */\r\n.mentors-page.dark-theme .mentor-task-card {\r\n    background-color: #2d3748 !important;\r\n    border-color: #4a5568 !important;\r\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2) !important;\r\n}\r\n\r\n.mentors-page.dark-theme .mentor-task-card:hover {\r\n    background-color: #374151 !important;\r\n    border-color: #6b7280 !important;\r\n    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3) !important;\r\n}\r\n\r\n.mentors-page.dark-theme .mentor-task-card.blocker {\r\n    background: #3d2a2a !important;\r\n    border-left: 5px solid #ef4444 !important;\r\n}\r\n\r\n.mentors-page.dark-theme .mentor-task-card.blocker:hover {\r\n    background: #4a3535 !important;\r\n}\r\n\r\n/* ТЕКСТ В КАРТКАХ ЗАДАЧ */\r\n.mentors-page.dark-theme .user-name {\r\n    color: #e2e8f0 !important;\r\n}\r\n\r\n.mentors-page.dark-theme .start-time {\r\n    background-color: #4a5568 !important;\r\n    color: #cbd5e0 !important;\r\n}\r\n\r\n.mentors-page.dark-theme .task-name {\r\n    color: #f7fafc !important;\r\n}\r\n\r\n.mentors-page.dark-theme .task-project {\r\n    background-color: #4a5568 !important;\r\n    color: #cbd5e0 !important;\r\n}\r\n\r\n.mentors-page.dark-theme .task-timer {\r\n    background-color: #4a5568 !important;\r\n    color: #e2e8f0 !important;\r\n}\r\n\r\n.mentors-page.dark-theme .task-link-arrow {\r\n    background-color: #4a5568 !important;\r\n    color: #9ca3af !important;\r\n}\r\n\r\n.mentors-page.dark-theme .mentor-task-card:hover .task-link-arrow {\r\n    color: #60a5fa !important;\r\n}\r\n\r\n/* ПРИХОВАНІ ЗАДАЧІ */\r\n.mentors-page.dark-theme .hidden-tasks-section {\r\n    border-top-color: #4a5568 !important;\r\n}\r\n\r\n.mentors-page.dark-theme .hidden-tasks-header {\r\n    background-color: #4a5568 !important;\r\n    color: #e2e8f0 !important;\r\n    border-color: #6b7280 !important;\r\n}\r\n\r\n.mentors-page.dark-theme .hidden-tasks-header:hover {\r\n    background-color: #565d6a !important;\r\n}\r\n\r\n.mentors-page.dark-theme .hidden-tasks-icon {\r\n    color: #cbd5e0 !important;\r\n}\r\n\r\n/* ПОВІДОМЛЕННЯ */\r\n.mentors-page.dark-theme .no-tasks-message {\r\n    background-color: #374151 !important;\r\n    color: #9ca3af !important;\r\n    border-color: #4a5568 !important;\r\n}\r\n\r\n/* КНОПКА ПОКАЗАТИ ВСІ */\r\n.mentors-page.dark-theme .show-all-tasks-btn {\r\n    background: #4a5568 !important;\r\n    border-color: #6b7280 !important;\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3) !important;\r\n}\r\n\r\n.mentors-page.dark-theme .show-all-tasks-btn:hover {\r\n    background: #5a6577 !important;\r\n    transform: translateY(-1px);\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.4) !important;\r\n}\r\n\r\n/* КОРИСТУВАЧІ КОЛОНКИ */\r\n.mentors-page.dark-theme .user-column {\r\n    background-color: #414752 !important;\r\n    border-color: #565d6a !important;\r\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3) !important;\r\n}\r\n\r\n.mentors-page.dark-theme .user-header {\r\n    background: linear-gradient(135deg, #4a5568 0%, #5a6577 100%) !important;\r\n    border-bottom-color: #6b7280 !important;\r\n}\r\n\r\n.mentors-page.dark-theme .user-header:hover {\r\n    background: linear-gradient(135deg, #5a6577 0%, #6b7280 100%) !important;\r\n}\r\n\r\n.mentors-page.dark-theme .user-header .user-name {\r\n    color: #ffffff !important;\r\n}\r\n\r\n.mentors-page.dark-theme .user-statuses {\r\n    background-color: #414752 !important;\r\n}\r\n\r\n/* КНОПКА ЗГОРНУТИ */\r\n.mentors-page.dark-theme .collapse-btn {\r\n    background: rgba(255, 255, 255, 0.2) !important;\r\n    border-color: #6b7280 !important;\r\n    color: #e2e8f0 !important;\r\n}\r\n\r\n.mentors-page.dark-theme .collapse-btn:hover {\r\n    background: rgba(255, 255, 255, 0.3) !important;\r\n    border-color: #9ca3af !important;\r\n}\r\n\r\n/* СТАТУСИ - залишаються кольоровими як у світлій темі */\r\n.mentors-page.dark-theme .status-section {\r\n    background: white !important;\r\n    border-color: #e2e8f0 !important;\r\n}\r\n\r\n.mentors-page.dark-theme .status-header {\r\n    background: #f8fafc !important;\r\n    border-bottom-color: #e2e8f0 !important;\r\n}\r\n\r\n.mentors-page.dark-theme .status-header:hover {\r\n    background: #edf2f7 !important;\r\n}\r\n\r\n.mentors-page.dark-theme .status-name {\r\n    color: #1a202c !important;\r\n}\r\n\r\n.mentors-page.dark-theme .task-count {\r\n    background: #e2e8f0 !important;\r\n    color: #4a5568 !important;\r\n}\r\n\r\n.mentors-page.dark-theme .collapse-icon {\r\n    color: #718096 !important;\r\n}\r\n\r\n/* СПИСОК ЗАДАЧ */\r\n.mentors-page.dark-theme .tasks-list {\r\n    background: white !important;\r\n}\r\n\r\n.mentors-page.dark-theme .task-item-wrapper {\r\n    background: white !important;\r\n    border-bottom-color: #f0f4f8 !important;\r\n}\r\n\r\n.mentors-page.dark-theme .task-item-wrapper:hover {\r\n    background: #f8fafc !important;\r\n}\r\n\r\n.mentors-page.dark-theme .task-name-small {\r\n    color: #1a202c !important;\r\n}\r\n\r\n.mentors-page.dark-theme .task-time-small {\r\n    color: #718096 !important;\r\n}\r\n\r\n.mentors-page.dark-theme .task-link-small {\r\n    background: #ebf8ff !important;\r\n    color: #4299e1 !important;\r\n}\r\n\r\n.mentors-page.dark-theme .task-item-wrapper:hover .task-link-small {\r\n    color: #2b6cb0 !important;\r\n}\r\n\r\n/* СКРОЛ В ТЕМНІЙ ТЕМІ */\r\n.mentors-page.dark-theme .tasks-container::-webkit-scrollbar-track,\r\n.mentors-page.dark-theme .tasks-list::-webkit-scrollbar-track {\r\n    background: #2d3748 !important;\r\n}\r\n\r\n.mentors-page.dark-theme .tasks-container::-webkit-scrollbar-thumb,\r\n.mentors-page.dark-theme .tasks-list::-webkit-scrollbar-thumb {\r\n    background: #4a5568 !important;\r\n}\r\n\r\n.mentors-page.dark-theme .tasks-container::-webkit-scrollbar-thumb:hover,\r\n.mentors-page.dark-theme .tasks-list::-webkit-scrollbar-thumb:hover {\r\n    background: #6b7280 !important;\r\n}\r\n\r\n/* LOADING ТА ERROR */\r\n.mentors-page.dark-theme .loading,\r\n.mentors-page.dark-theme .error {\r\n    color: #e2e8f0 !important;\r\n}\r\n\r\n.mentors-page.dark-theme .error {\r\n    color: #f87171 !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
